(() => {
  const roots = document.querySelectorAll('.gc-product-information[data-section-id]');

  roots.forEach((root) => {
    if (root.dataset.gcProductInformationInitialized === 'true') return;
    root.dataset.gcProductInformationInitialized = 'true';

    const configElement = root.querySelector('[data-gc-product-config]');
    if (!(configElement instanceof HTMLScriptElement)) return;

    let config;
    try {
      config = JSON.parse(configElement.textContent || '{}');
    } catch {
      return;
    }

    const normalizeCaseMediaAlt = (value) => String(value || '').trim();

    const sectionElement = root.closest('.shopify-section');
    const detailsCard = root.querySelector('.gc-buy-card');
    const detailsInner = root.querySelector('[data-gc-details-inner]');
    const customUiWrap = root.querySelector('[data-gc-brand-model-ui]');
    const brandButtonsWrap = root.querySelector('[data-gc-brand-buttons]');
    const modelSelectCustom = root.querySelector('[data-gc-model-select]');
    const finishButtonsWrap = root.querySelector('[data-gc-finish-buttons]');
    const brandGroup = root.querySelector('[data-gc-brand-group]');
    const modelGroup = root.querySelector('[data-gc-model-group]');
    const finishGroup = root.querySelector('[data-gc-finish-group]');
    const variantsJsonEl = root.querySelector('[data-gc-variants-json]');
    const priceCurrentEl = root.querySelector('[data-gc-price-current]');
    let priceCompareEl = root.querySelector('[data-gc-price-compare]');
    let priceBadgeEl = root.querySelector('[data-gc-price-badge]');
    const relatedRecommendationsSlot = root.querySelector('[data-gc-related-recommendations-slot]');
    const infoTabsWrap = root.querySelector('[data-gc-info-tabs]');
    const reviewToggle = root.querySelector('[data-gc-review-toggle]');
    const reviewList = root.querySelector('[data-gc-review-list]');
    const personalizeButton = root.querySelector('.gc-create-own-case-button');
    let unavailableRequestedModel = '';
    let modelRequirementNotice = null;

    const updateModelPurchaseState = (variant = null) => {
      const blocked = Boolean(unavailableRequestedModel);
      root.dataset.gcRequestedModel = unavailableRequestedModel;
      if (!modelRequirementNotice && modelSelectCustom) {
        modelRequirementNotice = document.createElement('p');
        modelRequirementNotice.setAttribute('role', 'status');
        modelRequirementNotice.setAttribute('aria-live', 'polite');
        modelRequirementNotice.dataset.gcModelRequirement = 'true';
        modelSelectCustom.insertAdjacentElement('afterend', modelRequirementNotice);
      }
      if (modelRequirementNotice) {
        const text = blocked
          ? `This case is not available for ${unavailableRequestedModel}. Choose a compatible phone model, or select another case style.`
          : '';
        if (modelRequirementNotice.textContent !== text) modelRequirementNotice.textContent = text;
        modelRequirementNotice.hidden = !blocked;
      }
      const scope = sectionElement || root;
      scope.querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"], sticky-add-to-cart button').forEach((button) => {
        if (blocked) {
          button.dataset.gcModelBlocked = 'true';
          if (!button.disabled) button.disabled = true;
        } else if (button.dataset.gcModelBlocked === 'true') {
          delete button.dataset.gcModelBlocked;
          button.disabled = variant?.available === false;
        }
      });
      const checkout = detailsCard?.querySelector('.accelerated-checkout-block');
      if (checkout && checkout.hidden !== blocked) checkout.hidden = blocked;
      if (blocked && modelSelectCustom) {
        const placeholder = modelSelectCustom.querySelector('option[value=""]');
        if (placeholder) placeholder.textContent = unavailableRequestedModel;
        modelSelectCustom.value = '';
        if (modelGroup) modelGroup.hidden = false;
      }
    };

    const preventUnsupportedPurchase = (event) => {
      if (!unavailableRequestedModel) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const form = target.closest('form');
      const control = target.closest('button[type="submit"], input[type="submit"], [name="add"], .accelerated-checkout-block');
      if (event.type !== 'submit' && !control) return;
      if (!root.contains(target) && !(sectionElement?.contains(target)) && !root.contains(control?.form || form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      modelRequirementNotice?.scrollIntoView({ block: 'nearest' });
    };
    document.addEventListener('submit', preventUnsupportedPurchase, true);
    document.addEventListener('click', preventUnsupportedPurchase, true);

    const notifyStickyReady = (variant = null, finish = '') => {
      root.dataset.gcRequestedModel = unavailableRequestedModel;
      if (!sectionElement) return;

      sectionElement.dispatchEvent(new CustomEvent('gc:product-ready', {
        bubbles: true,
        detail: {
          variantId: variant?.id ? String(variant.id) : '',
          finish,
          variantAvailable: unavailableRequestedModel ? false : typeof variant?.available === 'boolean' ? variant.available : null
        }
      }));
    };

    const stickyButtonLabels = config.stickyButtonLabels || {};

    const clearBootingState = () => {
      document.documentElement.classList.remove('gc-product-booting');
    };

    const getAcceleratedCheckoutBlock = () => detailsCard?.querySelector('.accelerated-checkout-block');

    let paymentReadyNode = null;
    let paymentReadyNodeVisible = false;
    let paymentSizeObserver = null;

    const applyPaymentButtonState = (checkoutBlock, isReady) => {
      if (checkoutBlock.classList.contains('gc-payment-loading') === isReady) {
        checkoutBlock.classList.toggle('gc-payment-loading', !isReady);
      }
      if (checkoutBlock.classList.contains('gc-payment-ready') !== isReady) {
        checkoutBlock.classList.toggle('gc-payment-ready', isReady);
      }
      if (checkoutBlock.hidden !== Boolean(unavailableRequestedModel)) checkoutBlock.hidden = Boolean(unavailableRequestedModel);
    };

    const syncPaymentButtonState = () => {
      const checkoutBlock = getAcceleratedCheckoutBlock();
      const readyNode = checkoutBlock?.querySelector(
        '.shopify-payment-button__button, .shopify-payment-button__button--unbranded, iframe'
      ) || null;

      if (readyNode !== paymentReadyNode) {
        paymentSizeObserver?.disconnect();
        paymentReadyNode = readyNode;
        paymentReadyNodeVisible = readyNode?.tagName === 'IFRAME';

        if (readyNode && readyNode.tagName !== 'IFRAME' && typeof ResizeObserver === 'function') {
          paymentSizeObserver ||= new ResizeObserver((entries) => {
            const entry = entries.find((item) => item.target === paymentReadyNode);
            if (!entry || !root.isConnected) return;
            const box = entry.borderBoxSize?.[0] || entry.borderBoxSize;
            paymentReadyNodeVisible = box
              ? box.inlineSize > 0 && box.blockSize > 0
              : entry.contentRect.width > 0 && entry.contentRect.height > 0;
            const currentBlock = getAcceleratedCheckoutBlock();
            if (currentBlock?.contains(paymentReadyNode)) {
              applyPaymentButtonState(currentBlock, paymentReadyNodeVisible);
            }
          });
          paymentSizeObserver.observe(readyNode);
        }
      }

      if (!checkoutBlock) return;
      if (readyNode && readyNode.tagName !== 'IFRAME' && typeof ResizeObserver !== 'function') {
        paymentReadyNodeVisible = Boolean(readyNode.getClientRects().length);
      }
      applyPaymentButtonState(checkoutBlock, Boolean(readyNode && paymentReadyNodeVisible));
    };

    if (
      !detailsCard ||
      !detailsInner ||
      !customUiWrap ||
      !brandButtonsWrap ||
      !modelSelectCustom ||
      !finishButtonsWrap
    ) {
      notifyStickyReady();
      clearBootingState();
      return;
    }

    let isSyncingVariant = false;
    let hasBoundListeners = false;
    let hasUserChosenBrand = false;
    let hasAutoAlignedBrand = false;
    let hasAppliedIncomingSelection = false;
    let refreshUiFrame = 0;
    let lastRenderedNativeState = '';
    let paymentStateFrame = 0;
    let paymentStateObserver = null;

    const variants = (() => {
      try {
        return JSON.parse(variantsJsonEl?.textContent || '[]').map((variant) => {
          if (!variant?.media_src) return variant;
          return {
            ...variant,
            featured_media: {
              id: variant.media_id || '',
              alt: variant.media_alt || '',
              preview_image: { src: variant.media_src, alt: variant.media_alt || '' }
            },
            featured_image: { id: variant.media_id || '', src: variant.media_src, alt: variant.media_alt || '' }
          };
        });
      } catch (error) {
        return [];
      }
    })();

    const variantMediaMap = Object.fromEntries(variants.map((variant) => {
      const image = variant?.featured_media?.preview_image || variant?.featured_image;
      if (!variant?.id || !image?.src) return [String(variant?.id || ''), []];
      return [String(variant.id), [{
        id: variant?.featured_media?.id || variant?.featured_image?.id || '',
        src: image.src,
        alt: variant?.featured_media?.alt || image.alt || ''
      }]];
    }));
    const loadedVariantGalleries = new Map();

    const moneyFormat = config.moneyFormat;

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      const value = (Number(cents || 0) / 100).toFixed(2);
      return `$${value}`;
    };

    const ensureExtraPriceNodes = () => {
      if (!priceCurrentEl) return;

      const priceRow =
        priceCurrentEl.closest('[data-gc-price-row]') ||
        priceCurrentEl.parentElement;

      if (!priceRow) return;

      if (!priceCompareEl) {
        priceCompareEl = document.createElement('span');
        priceCompareEl.setAttribute('data-gc-price-compare', '');
        priceCompareEl.hidden = true;
        priceCompareEl.style.textDecoration = 'line-through';
        priceCompareEl.style.opacity = '0.65';
        priceCompareEl.style.marginLeft = '8px';
        priceRow.appendChild(priceCompareEl);
      }

      if (!priceBadgeEl) {
        priceBadgeEl = document.createElement('span');
        priceBadgeEl.setAttribute('data-gc-price-badge', '');
        priceBadgeEl.hidden = true;
        priceBadgeEl.style.marginLeft = '8px';
        priceBadgeEl.style.padding = '4px 8px';
        priceBadgeEl.style.borderRadius = '999px';
        priceBadgeEl.style.fontSize = '12px';
        priceBadgeEl.style.fontWeight = '600';
        priceBadgeEl.style.lineHeight = '1';
        priceBadgeEl.style.background = '#FDF0ED';
        priceBadgeEl.style.color = '#C24A3E';
        priceRow.appendChild(priceBadgeEl);
      }
    };

    const updateCustomPriceDisplay = (variant) => {
      if (!priceCurrentEl || !variant) return;

      ensureExtraPriceNodes();

      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);

      priceCurrentEl.textContent = formatMoney(price);

      if (compare > price) {
        const discount = Math.round(((compare - price) / compare) * 100);

        if (priceCompareEl) {
          priceCompareEl.hidden = false;
          priceCompareEl.textContent = formatMoney(compare);
        }

        if (priceBadgeEl) {
          priceBadgeEl.hidden = false;
          priceBadgeEl.textContent = `${discount}% OFF`;
        }
      } else {
        if (priceCompareEl) {
          priceCompareEl.hidden = true;
          priceCompareEl.textContent = '';
        }

        if (priceBadgeEl) {
          priceBadgeEl.hidden = true;
          priceBadgeEl.textContent = '';
        }
      }
    };

    const updateStickyBarState = (variant) => {
      if (!sectionElement) return;

      const stickyAddToCart = sectionElement.querySelector('sticky-add-to-cart');
      if (!(stickyAddToCart instanceof HTMLElement)) return;

      const stickyVariantTitle = stickyAddToCart.querySelector('.sticky-add-to-cart__variant');
      const stickyPrice = stickyAddToCart.querySelector('.sticky-add-to-cart__price');
      const stickyImage = stickyAddToCart.querySelector('.sticky-add-to-cart__image-img');
      const stickyButton = stickyAddToCart.querySelector('.sticky-add-to-cart__button');
      const stickyButtonContent = stickyButton?.querySelector('.add-to-cart-text__content');
      const stickyButtonLabel = stickyButtonContent?.firstElementChild;
      const stickyButtonIcon = stickyButton?.querySelector('.add-to-cart-icon');
      const resolvedVariantId = variant?.id ? String(variant.id) : '';
      const isAvailable = Boolean(variant && variant.available !== false);
      const variantTitle = [
        normalizeModel(getVariantModel(variant)),
        normalizeText(stickyAddToCart.dataset.gcCaseLabel || '')
      ].filter(Boolean).join(' · ');
      const shouldShowVariantTitle = Boolean(variantTitle);

      stickyAddToCart.dataset.currentVariantId = resolvedVariantId;
      stickyAddToCart.dataset.variantAvailable = String(isAvailable);

      if (stickyVariantTitle instanceof HTMLElement) {
        stickyVariantTitle.textContent = shouldShowVariantTitle ? variantTitle : '';
        stickyVariantTitle.style.display = shouldShowVariantTitle ? '' : 'none';
      }

      if (stickyPrice instanceof HTMLElement && variant) {
        const price = Number(variant.price || 0);
        const compare = Number(variant.compare_at_price || 0);

        stickyPrice.innerHTML = '';

        const priceNode = document.createElement('span');
        priceNode.className = 'price';
        priceNode.textContent = formatMoney(price);
        stickyPrice.appendChild(priceNode);

        if (compare > price) {
          const compareNode = document.createElement('span');
          compareNode.className = 'compare-at-price';
          compareNode.textContent = formatMoney(compare);
          compareNode.style.marginLeft = '8px';
          compareNode.style.textDecoration = 'line-through';
          compareNode.style.opacity = '0.65';
          stickyPrice.appendChild(compareNode);
        }
      }

      if (stickyImage instanceof HTMLImageElement && variant) {
        const nextImage =
          variant.featured_media?.preview_image?.src ||
          variant.featured_image?.src ||
          '';
        const nextAlt = normalizeCaseMediaAlt(
          variant.featured_media?.alt ||
          variant.featured_image?.alt ||
          config.productTitle
        );

        if (nextImage) {
          const thumbnailUrl = new URL(nextImage, window.location.origin);
          thumbnailUrl.searchParams.set('width', '120');
          if (stickyImage.src !== thumbnailUrl.href) stickyImage.src = thumbnailUrl.href;
        }
        if (nextAlt) {
          stickyImage.alt = nextAlt;
          stickyImage.setAttribute('alt', nextAlt);
        }
      }

      if (stickyButton instanceof HTMLButtonElement) {
        stickyButton.disabled = !isAvailable;
      }

      if (stickyButtonLabel instanceof HTMLElement) {
        if (!variant) {
          stickyButtonLabel.textContent = stickyButtonLabels.unavailable;
        } else {
          stickyButtonLabel.textContent = isAvailable
            ? stickyButtonLabels.addToCart
            : stickyButtonLabels.soldOut;
        }
      }

      if (stickyButtonIcon instanceof HTMLElement) {
        stickyButtonIcon.hidden = !isAvailable;
      }
    };

    const iphoneOrder = [
      'iPhone 18 Pro Max',
      'iPhone 18 Pro',
      'iPhone 17 Pro Max',
      'iPhone 17 Pro',
      'iPhone 17 Air',
      'iPhone 17e',
      'iPhone 17',
      'iPhone 16 Pro Max',
      'iPhone 16 Pro',
      'iPhone 16 Plus',
      'iPhone 16',
      'iPhone 16e',
      'iPhone 15 Pro Max',
      'iPhone 15 Pro',
      'iPhone 15 Plus',
      'iPhone 15',
      'iPhone 14 Pro Max',
      'iPhone 14 Pro',
      'iPhone 14 Plus',
      'iPhone 14',
      'iPhone 13 Pro Max',
      'iPhone 13 Pro',
      'iPhone 13 Mini',
      'iPhone 13',
      'iPhone 12 Pro Max',
      'iPhone 12 Pro',
      'iPhone 12 Mini',
      'iPhone 12',
      'iPhone 11 Pro Max',
      'iPhone 11 Pro',
      'iPhone 11',
      'iPhone XS Max',
      'iPhone XS',
      'iPhone XR',
      'iPhone X',
      'iPhone 8 Plus',
      'iPhone 8',
      'iPhone 7 Plus',
      'iPhone 7'
    ];

    const samsungOrder = [
      'Samsung Galaxy S26 Ultra',
      'Samsung Galaxy S26 Plus',
      'Samsung Galaxy S26',
      'Samsung Galaxy S25 Ultra',
      'Samsung Galaxy S25 Plus',
      'Samsung Galaxy S25',
      'Samsung Galaxy S24 Ultra',
      'Samsung Galaxy S24 Plus',
      'Samsung Galaxy S24',
      'Samsung Galaxy S23 Ultra',
      'Samsung Galaxy S23 Plus',
      'Samsung Galaxy S23',
      'Samsung Galaxy S22 Ultra',
      'Samsung Galaxy S22 Plus',
      'Samsung Galaxy S22',
      'Samsung Galaxy S21 Ultra',
      'Samsung Galaxy S21 Plus',
      'Samsung Galaxy S21'
    ];

    const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    // Horizon appends availability copy to the label. Matching must use the
    // canonical value, otherwise "S26 - Unavailable" becomes a different model.
    const getOptionText = (opt) => normalizeText(opt?.value ?? opt?.text ?? '');
    const pageParams = new URLSearchParams(window.location.search);
    const selectedPhoneBrandStorageKey = 'gc_selected_phone_brand';
    const selectedPhoneModelStorageKey = 'gc_selected_phone_model';
    const writePhoneStorage = (key, value) => {
      try {
        if (value) {
          window.localStorage.setItem(key, value);
        } else {
          window.localStorage.removeItem(key);
        }
      } catch (error) {
        // Variant selection remains functional when storage is unavailable.
      }
    };
    const normalizeCaseKey = (value) => {
      const normalized = normalizeText(value).toLowerCase().replace(/-/g, '_');
      if (!normalized) return '';
      if (
        normalized === 'tough_case' ||
        normalized === 'custom_tough_case'
      ) {
        return 'tough_case';
      }
      if (
        normalized === 'tough_magsafe' ||
        normalized === 'tough_magsafe_case' ||
        normalized === 'custom_tough_magsafe_case'
      ) {
        return 'tough_magsafe_case';
      }
      if (
        normalized === 'clear_magsafe' ||
        normalized === 'clear_magsafe_case' ||
        normalized === 'custom_clear_magsafe_case'
      ) {
        return 'clear_magsafe_case';
      }
      if (
        normalized === 'biodegradable' ||
        normalized === 'biodegradable_case' ||
        normalized === 'custom_biodegradable_case'
      ) {
        return 'biodegradable_case';
      }
      if (
        normalized === 'frosted_clear' ||
        normalized === 'frosted_clear_case' ||
        normalized === 'custom_frosted_clear_case' ||
        normalized === 'samsung_clear' ||
        normalized === 'samsung_clear_case' ||
        normalized === 'clear_case'
      ) {
        return 'frosted_clear_case';
      }
      if (
        normalized === 'tough_magnetic' ||
        normalized === 'tough_magnetic_case' ||
        normalized === 'custom_tough_magnetic_case'
      ) {
        return 'tough_magnetic_case';
      }
      return '';
    };

    const getModelLookupKey = (value) => {
      let normalized = normalizeText(value)
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (/^galaxy\s/.test(normalized)) normalized = `samsung ${normalized}`;
      if (/^s\d/.test(normalized)) normalized = `samsung galaxy ${normalized}`;
      if (/^samsung\s+s\d/.test(normalized)) normalized = normalized.replace(/^samsung\s+/, 'samsung galaxy ');
      return normalized;
    };

    const normalizeModel = (value) => {
      const lookupKey = getModelLookupKey(value);
      if (!lookupKey) return '';

      const canonicalModel = [...iphoneOrder, ...samsungOrder].find((model) => {
        return getModelLookupKey(model) === lookupKey;
      });
      if (canonicalModel) return canonicalModel;

      return normalizeText(value)
        .replace(/[-_]+/g, ' ')
        .replace(/Iphone/gi, 'iPhone')
        .replace(/XS MAX/gi, 'XS Max')
        .replace(/Xs/gi, 'XS')
        .replace(/Xr/gi, 'XR')
        .replace(/^Galaxy /i, 'Samsung Galaxy ')
        .replace(/^Samsung S/i, 'Samsung Galaxy S')
        .replace(/^S(?=\d)/i, 'Samsung Galaxy S');
    };

    const unavailableFinishSuffixPattern = /\s*-\s*unavailable$/i;
    const normalizeFinish = (value) => normalizeText(value).replace(unavailableFinishSuffixPattern, '').trim();
    const incomingSelection = {
      source: normalizeText(pageParams.get('from') || ''),
      variantId: normalizeText(pageParams.get('variant') || ''),
      brand: (() => {
        const device = normalizeText(pageParams.get('device') || '').toLowerCase();
        if (device === 'samsung') return 'Samsung';
        if (device === 'iphone') return 'iPhone';
        if (normalizeText(pageParams.get('variant') || '')) return '';
        const titleLower = config.productTitleBrand.toLowerCase();
        if (titleLower.includes('iphone')) return 'iPhone';
        if (titleLower.includes('samsung') || titleLower.includes('galaxy')) return 'Samsung';
        return '';
      })(),
      model: '',
      finish: normalizeFinish(pageParams.get('finish') || ''),
      caseKey: normalizeCaseKey(pageParams.get('case') || pageParams.get('case_key') || '')
    };

    const hasExplicitUrlSelection = [
      'variant',
      'device',
      'model',
      'finish',
      'case',
      'case_key'
    ].some((key) => pageParams.has(key));

    const applyEntryContext = () => {
      if (hasExplicitUrlSelection) {
        window.GoCraftlyProductEntryContext?.clear?.();
        return;
      }

      const entryContext = window.GoCraftlyProductEntryContext?.consume?.(window.location.pathname);
      if (!entryContext) return;

      incomingSelection.source = 'entry-context';
      incomingSelection.model = normalizeModel(entryContext.model || '');
      incomingSelection.finish = normalizeFinish(entryContext.finish || '');
      incomingSelection.brand = entryContext.device === 'samsung'
        ? 'Samsung'
        : entryContext.device === 'iphone'
          ? 'iPhone'
          : incomingSelection.brand;
    };

    const getBrand = (model) => {
      const value = String(model || '').toLowerCase();
      if (value.includes('iphone')) return 'iPhone';
      if (value.includes('galaxy') || value.includes('samsung')) return 'Samsung';
      return 'Other';
    };

    const productTitleBrand = getBrand(config.productTitleBrand);

    const getCollectionContextBrand = () => {
  const params = new URLSearchParams(window.location.search);
  const device = (params.get('device') || '').toLowerCase();

  if (device === 'samsung') return 'Samsung';
  if (device === 'iphone') return 'iPhone';

  const currentUrl = (window.location.href || '').toLowerCase();
  const currentPath = (window.location.pathname || '').toLowerCase();

  const isSamsungSignal = (value) => {
    return value.includes('samsung');
  };

  const isIphoneSignal = (value) => {
    return value.includes('iphone');
  };

  if (isSamsungSignal(currentPath) || isSamsungSignal(currentUrl)) {
    return 'Samsung';
  }

  if (isIphoneSignal(currentPath) || isIphoneSignal(currentUrl)) {
    return 'iPhone';
  }

  return '';
};

    const nativeVariantUiHiddenClass = 'gc-native-variant-ui-hidden';
    const productOptionNames = (config.productOptionNames || [])
      .map((name) => normalizeText(name).toLowerCase())
      .filter(Boolean);

    const visuallyHideNativeVariantUi = (variantArea) => {
      if (!variantArea) return;
      variantArea.classList.add(nativeVariantUiHiddenClass);
    };

    const restoreNativeVariantUi = (variantArea) => {
      if (!variantArea) return;
      variantArea.classList.remove(nativeVariantUiHiddenClass);
    };

    const recommendationData = new WeakMap();
    const recommendationModelKey = (value) => {
      let key = String(value || '').trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
      if (/^galaxy\s/.test(key)) key = `samsung ${key}`;
      if (/^s\d/.test(key)) key = `samsung galaxy ${key}`;
      return key.replace(/^samsung\s+s(?=\d)/, 'samsung galaxy s');
    };
    const resolveRecommendation = (products, model) => {
      const key = recommendationModelKey(model);
      if (!key || !Array.isArray(products) || !products.length || products.some((item) => !item.complete)) return null;
      const styles = new Set();
      let cheapest = null;
      for (const item of products) {
        for (const variant of item.variants || []) {
          if (variant.available !== true || recommendationModelKey(variant.model) !== key) continue;
          if (!Number.isFinite(variant.price) || variant.price < 0 || !variant.id || !item.url) continue;
          styles.add(String(item.family || item.url).replace(/_case$/, ''));
          if (!cheapest || variant.price < cheapest.price) cheapest = { ...variant, url: item.url };
        }
      }
      return cheapest ? { ...cheapest, count: styles.size } : null;
    };
    const updateStyleRecommendationLinks = (brand, model = '') => {
      const activeDevice = String(brand || '').toLowerCase() === 'samsung' ? 'samsung' : 'iphone';
      const canonicalModel = normalizeModel(model);
      let visibleCount = 0;

      root.querySelectorAll('[data-gc-style-link]').forEach((link) => {
        if (!(link instanceof HTMLAnchorElement)) return;
        if (!recommendationData.has(link)) {
          try {
            recommendationData.set(link, JSON.parse(link.querySelector('[data-gc-recommendation-model-data]')?.textContent || 'null'));
          } catch {
            recommendationData.set(link, null);
          }
        }
        const result = resolveRecommendation(recommendationData.get(link), canonicalModel);
        const sameDevice = link.dataset.gcStyleDevice === activeDevice;
        link.hidden = !result || !sameDevice;
        if (link.hidden) return;

        const targetUrl = new URL(result.url, window.location.origin);
        targetUrl.searchParams.set('variant', String(result.id));
        targetUrl.searchParams.set('model', canonicalModel);
        targetUrl.searchParams.set('device', activeDevice);
        link.dataset.gcDevice = activeDevice;
        link.dataset.gcModel = canonicalModel;
        link.setAttribute('href', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
        const tag = link.querySelector('.gc-reco-card__tag');
        const price = link.querySelector('.gc-reco-card__price-current');
        if (tag) tag.textContent = result.count === 1 ? config.recommendationLabels.one
          : config.recommendationLabels.many.replace('[count]', String(result.count));
        if (price) {
          const formatted = new DOMParser().parseFromString(result.money, 'text/html').body.textContent;
          price.textContent = config.recommendationLabels.from.replace('[price]', formatted);
        }
        visibleCount += 1;
      });
      const section = root.querySelector('[data-gc-related-recommendations]');
      if (section) section.hidden = visibleCount === 0;
    };

    let recommendationSelection = null;
    const updateBrandRecommendations = (brand, model = '') => {
      // Recommendation fetch may complete after boot or a brand/model change.
      // An unavailable requested model is still the shopper's intended phone.
      const selectedModel = unavailableRequestedModel || model || '';
      const modelBrand = getBrand(selectedModel);
      const selectedBrand = modelBrand !== 'Other' ? modelBrand : (brand || productTitleBrand);
      const normalized = String(selectedBrand || '').toLowerCase() === 'samsung' ? 'samsung' : 'iphone';
      recommendationSelection = { brand: selectedBrand, model: selectedModel };

      root.querySelectorAll('[data-gc-brand-reco]').forEach((el) => {
        el.hidden = el.getAttribute('data-gc-brand-reco') !== normalized;
      });

      root.querySelectorAll('[data-gc-brand-like]').forEach((el) => {
        el.hidden = el.getAttribute('data-gc-brand-like') !== normalized;
      });

      const styleAllLink = root.querySelector('[data-gc-style-all-link]');
      if (styleAllLink) {
        const collectionUrl = new URL(
          normalized === 'samsung' ? config.samsungAllCollectionUrl : config.iphoneAllCollectionUrl,
          window.location.origin
        );
        if (selectedModel) collectionUrl.searchParams.set('model', selectedModel);
        styleAllLink.setAttribute('href', `${collectionUrl.pathname}${collectionUrl.search}${collectionUrl.hash}`);
      }

      updateStyleRecommendationLinks(selectedBrand, selectedModel);
    };

    let recommendationsLoaded = false;

    const loadRecommendations = async () => {
      if (
        recommendationsLoaded ||
        !(relatedRecommendationsSlot instanceof HTMLElement) ||
        !config.recommendationsUrl
      ) return;

      recommendationsLoaded = true;

      try {
        const response = await fetch(config.recommendationsUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) return;

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const relatedRecommendations = documentFragment.querySelector('[data-gc-related-recommendations]');
        if (!relatedRecommendations) return;

        relatedRecommendationsSlot.replaceWith(relatedRecommendations);
        // getCurrentModelText is scoped inside boot and is unavailable here.
        updateBrandRecommendations(
          recommendationSelection?.brand ?? incomingSelection.brand,
          recommendationSelection?.model ?? incomingSelection.model
        );
      } catch {
        // Recommendations are intentionally non-critical and must not affect buying.
      }
    };

    const setupCaseAccordions = () => {
      root.querySelectorAll('[data-gc-case-accordion]').forEach((accordion) => {
        if (accordion.dataset.gcCaseAccordionReady === 'true') return;
        accordion.dataset.gcCaseAccordionReady = 'true';

        accordion.querySelectorAll('[data-gc-case-accordion-button]').forEach((button) => {
          if (!(button instanceof HTMLButtonElement)) return;
          button.addEventListener('click', () => {
            const shouldOpen = button.getAttribute('aria-expanded') !== 'true';

            const panelId = button.getAttribute('aria-controls');
            const panel = panelId ? root.querySelector(`#${panelId}`) : null;
            if (!(panel instanceof HTMLElement)) return;
            button.setAttribute('aria-expanded', String(shouldOpen));
            panel.classList.toggle('is-open', shouldOpen);
            panel.setAttribute('aria-hidden', String(!shouldOpen));
            panel.toggleAttribute('inert', !shouldOpen);
          });
        });
      });
    };

    const activateInfoPanel = (key) => {
      root.querySelectorAll('[data-gc-info-tab]').forEach((btn) => {
        btn.classList.toggle('active', btn.getAttribute('data-gc-info-tab') === key);
      });

      root.querySelectorAll('[data-gc-info-panel]').forEach((panel) => {
        panel.classList.toggle('active', panel.getAttribute('data-gc-info-panel') === key);
      });
    };

    const scrollReviewsBackIntoView = () => {
      const infoSection = root.querySelector('#gc-product-information-tabs');
      const target = reviewList || infoSection;
      if (!(target instanceof HTMLElement)) return;

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const targetRect = target.getBoundingClientRect();
      const targetTop = window.pageYOffset + targetRect.top;
      const currentTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      let offset = 56;
      if (viewportWidth <= 767) {
        offset = Math.max(24, Math.round(viewportHeight * 0.22));
      } else if (viewportWidth <= 1024) {
        offset = 96;
      }

      const nextTop = Math.max(0, targetTop - offset);
      if (nextTop >= currentTop - 8) return;

      window.scrollTo({
        top: nextTop,
        behavior: 'instant',
      });
    };

    const findVariantArea = () => {
      const candidates = [
        detailsCard.querySelector('variant-picker'),
        detailsCard.querySelector('.variant-picker'),
        detailsCard.querySelector('[data-variant-picker]'),
        detailsCard.querySelector('product-form'),
        detailsCard.querySelector('form[action*="/cart/add"]')
      ].filter(Boolean);

      if (candidates.length) return candidates[0];

      const sizeLabel = Array.from(detailsCard.querySelectorAll('label')).find((label) => {
        const text = (label.textContent || '').toLowerCase().trim();
        return text.includes('size') || text.includes('model');
      });

      if (sizeLabel) {
        return (
          sizeLabel.closest('.product-form__input') ||
          sizeLabel.closest('.product-form') ||
          sizeLabel.parentElement ||
          detailsCard
        );
      }

      return detailsCard;
    };

    const getForm = () => {
      return (
        detailsCard.querySelector('form[action*="/cart/add"]') ||
        detailsCard.querySelector('product-form form') ||
        detailsCard.querySelector('product-form')
      );
    };

    const getVariantIdInput = () => {
      return (
        detailsCard.querySelector('form[action*="/cart/add"] [name="id"]') ||
        detailsCard.querySelector('product-form [name="id"]')
      );
    };

      const getCurrentVariantId = () => normalizeText(getVariantIdInput()?.value || '');

      const getCurrentVariantFromForm = () => {
        const variantId = getCurrentVariantId();
        if (!variantId) return null;
        return variants.find((variant) => String(variant.id) === String(variantId)) || null;
      };

      const doesCurrentVariantMatchSelection = () => {
        const currentVariant = getCurrentVariantFromForm();
        if (!currentVariant) return false;

        const selectedModel = normalizeModel(getCurrentModelText());
        const selectedFinish = normalizeFinish(getCurrentFinishText());
        const variantOptions = [
          currentVariant.option1,
          currentVariant.option2,
          currentVariant.option3
        ]
          .map((value) => normalizeText(value))
          .filter(Boolean);

        const modelMatches = !selectedModel || variantOptions.some((value) => normalizeModel(value) === selectedModel);
        const finishMatches =
          !selectedFinish || variantOptions.some((value) => normalizeFinish(value) === selectedFinish);

        return modelMatches && finishMatches;
      };

      const findVariantForSelection = (modelValue = '', finishValue = '') => {
        const selectedModel = normalizeModel(modelValue);
        const selectedFinish = normalizeFinish(finishValue);
        const matchingVariants = variants.filter((variant) => {
          const variantOptions = [variant.option1, variant.option2, variant.option3]
            .map((value) => normalizeText(value))
            .filter(Boolean);

          const modelMatches =
            !selectedModel || variantOptions.some((value) => normalizeModel(value) === selectedModel);
          const finishMatches =
            !selectedFinish || variantOptions.some((value) => normalizeFinish(value) === selectedFinish);

          return modelMatches && finishMatches;
        });

        return matchingVariants.find((variant) => variant.available !== false) || matchingVariants[0] || null;
      };

      let activeMediaGalleryFilterVariant = null;
      let mediaGalleryObserver = null;
      let mediaGalleryObserverFrame = 0;
      let mediaGalleryFilterTimer = 0;
      let activeGalleryThumbnailTap = null;
      let manualGallerySelection = null;
      let lastHandledGalleryThumbnailTapAt = 0;
      let lastResolvedMediaVariantId = '';
      let mediaGallerySyncToken = 0;
      const mediaGallerySyncRetryDelays = [400, 600];
      const galleryThumbnailTapMaxDistance = 12;

      const debugMediaSync = () => {};

      const getVariantSyncDebugInfo = (variant) => ({
        id: variant?.id || null,
        title: variant?.title || '',
        option1: variant?.option1 || '',
        option2: variant?.option2 || '',
        option3: variant?.option3 || '',
        featuredMediaId: variant?.featured_media?.id || null,
        featuredImageId: variant?.featured_image?.id || null,
        inputId: getVariantIdInput()?.value || '',
      });

      const getMediaGalleryDebugInfo = () => {
        const galleries = Array.from(root.querySelectorAll('.gc-hero-image-wrap media-gallery'));

        return galleries.map((gallery, index) => {
          const rect = gallery.getBoundingClientRect();
          const slideshow = gallery.slideshow;
          const slides = Array.from(slideshow?.refs?.slides || []);
          const currentSlide = slideshow?.slides?.[slideshow.current];
          const currentSlideMediaId =
            currentSlide?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
            currentSlide?.getAttribute?.('data-media-id') ||
            '';

          return {
            index,
            visible:
              rect.width > 0 &&
              rect.height > 0 &&
              window.getComputedStyle(gallery).display !== 'none' &&
              window.getComputedStyle(gallery).visibility !== 'hidden',
            rect: {
              x: Math.round(rect.x),
              y: Math.round(rect.y),
              width: Math.round(rect.width),
              height: Math.round(rect.height),
            },
            hidden: gallery.hidden,
            ariaHidden: gallery.getAttribute('aria-hidden'),
            hasSlideshow: Boolean(slideshow),
            slideCount: slides.length,
            currentIndex: slideshow?.current ?? null,
            currentSlideMediaId,
            classes: gallery.className,
          };
        });
      };

      const syncResolvedVariantState = (variant) => {
        if (!variant) return;

        const resolvedVariantId = String(variant.id);
        if (lastResolvedMediaVariantId !== resolvedVariantId) {
          manualGallerySelection = null;
          lastResolvedMediaVariantId = resolvedVariantId;
        }
        const variantIdInput = getVariantIdInput();
        if (variantIdInput && String(variantIdInput.value) !== resolvedVariantId) {
          variantIdInput.value = resolvedVariantId;
          variantIdInput.setAttribute('value', resolvedVariantId);
        }

        const productFormComponent = detailsCard.querySelector('product-form-component');
        productFormComponent?.applyResolvedVariant?.(resolvedVariantId, variant.available !== false);

        const addToCartComponent = detailsCard.querySelector('add-to-cart-component');
        const variantMedia =
          variant.featured_media?.preview_image?.src ||
          variant.featured_image?.src ||
          '';

        if (variantMedia && addToCartComponent instanceof HTMLElement) {
          addToCartComponent.setAttribute('data-product-variant-media', `${variantMedia}&width=100`);
        }

        updateStickyBarState(variant);
        document.dispatchEvent(new CustomEvent('gc:product-variant-change', {
          detail: {
            productId: String(root.dataset.productId || ''),
            variantId: resolvedVariantId,
            brand: getBrand(getVariantModel(variant)),
            model: getVariantModel(variant),
            finish: getVariantFinish(variant)
          }
        }));
      };

      const getVariantModel = (variant) => {
        if (!variant) return '';
        return [variant.option1, variant.option2, variant.option3]
          .map((value) => normalizeModel(value))
          .find((value) => {
            const brand = getBrand(value);
          return brand === 'iPhone' || brand === 'Samsung';
        }) || '';
      };

      const getVariantFinish = (variant) => {
        if (!variant) return '';
        return [variant.option1, variant.option2, variant.option3]
          .map((value) => normalizeFinish(value))
          .find((value) => /(?:glossy|matte)/i.test(value)) || '';
      };

      const getMediaKeyFromSrc = (src = '') => {
        const cleanSrc = String(src || '').split('?')[0];
        return cleanSrc.split('/').pop() || cleanSrc;
      };

      const collectVariantMediaKeys = (variant) => {
        const keys = new Set();
        const mediaId = variant?.featured_media?.id || variant?.featured_image?.id || '';

        if (mediaId) keys.add(String(mediaId));

        [
          variant?.featured_media?.preview_image?.src,
          variant?.featured_media?.preview_image?.url,
          variant?.featured_image?.src,
          variant?.featured_image?.url
        ].forEach((src) => {
          const key = getMediaKeyFromSrc(src);
          if (key) keys.add(key);
        });

        return keys;
      };

      const collectElementMediaKeys = (element) => {
        const keys = new Set();
        const mediaId =
          element?.getAttribute?.('data-media-id') ||
          element?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
          '';
        const image = element?.querySelector?.('img');
        const imageKey = getMediaKeyFromSrc(
          image?.currentSrc ||
          image?.src ||
          image?.getAttribute?.('src') ||
          ''
        );

        if (mediaId) keys.add(String(mediaId));
        if (imageKey) keys.add(imageKey);

        return keys;
      };

      const getMediaGalleryWrap = () => root.querySelector('.gc-hero-image-wrap');

      const setMediaGalleryFilterPending = (isPending) => {
        const galleryWrap = getMediaGalleryWrap();
        if (!galleryWrap) return;

        if (isPending) {
          galleryWrap.setAttribute('data-gc-media-filter-pending', 'true');
        } else {
          galleryWrap.removeAttribute('data-gc-media-filter-pending');
        }
      };

      const getMediaGallery = () => getMediaGalleryWrap()?.querySelector('media-gallery') || null;

      const defaultGalleryImageWidths = [240, 352, 832, 1200, 1600, 1920];

      const getSanitizedMediaUrl = (src = '') => {
        const normalizedSrc = String(src || '').replace(/&amp;/g, '&').trim();
        if (!normalizedSrc) return '';

        const [path, query = ''] = normalizedSrc.split('?');
        const params = new URLSearchParams(query);
        params.delete('width');

        const serializedParams = params.toString();
        return serializedParams ? `${path}?${serializedParams}` : path;
      };

      const getSizedMediaUrl = (src = '', width = 0) => {
        const cleanSrc = getSanitizedMediaUrl(src);
        if (!cleanSrc) return '';

        const parsedWidth = Number(width || 0);
        if (!parsedWidth) return cleanSrc;

        return `${cleanSrc}${cleanSrc.includes('?') ? '&' : '?'}width=${Math.round(parsedWidth)}`;
      };

      const getGalleryImageWidths = (image) => {
        if (!(image instanceof HTMLImageElement)) return defaultGalleryImageWidths;

        const srcset = image.getAttribute('srcset') || '';
        const widths = Array.from(srcset.matchAll(/(\d+)w/g))
          .map((match) => Number(match[1]))
          .filter((width) => width > 0);

        return widths.length ? Array.from(new Set(widths)) : defaultGalleryImageWidths;
      };

      const updateGalleryImageSource = (image, src, widths) => {
        if (!(image instanceof HTMLImageElement) || !src) return;

        const safeWidths = widths.length ? widths : defaultGalleryImageWidths;
        const fallbackWidth = Number(image.getAttribute('width') || 0) || safeWidths[safeWidths.length - 1] || 1920;
        const srcset = safeWidths.map((width) => `${getSizedMediaUrl(src, width)} ${width}w`).join(', ');
        const nextSrc = getSizedMediaUrl(src, fallbackWidth);

        if (srcset && image.getAttribute('srcset') !== srcset) {
          image.setAttribute('srcset', srcset);
        }
        if (image.getAttribute('src') !== nextSrc) image.setAttribute('src', nextSrc);
      };

      const applyImmediateGalleryPreviewForVariant = (variant) => {
        if (!variant) return false;

        const gallery = getMediaGallery();
        if (!gallery) return false;

        const slideshow = gallery.slideshow;
        const currentSlide =
          slideshow?.slides?.[slideshow.current] ||
          gallery.querySelector('slideshow-slide:not([hidden])') ||
          gallery.querySelector('slideshow-slide');

        if (!(currentSlide instanceof HTMLElement)) return false;

        const previewImage = variant?.featured_media?.preview_image || variant?.featured_image;
        const previewSrc = previewImage?.src || previewImage?.url || '';
        if (!previewSrc) return false;

        const visibleImages = Array.from(currentSlide.querySelectorAll('img'));
        if (!visibleImages.length) return false;

        const mediaId = String(variant?.featured_media?.id || variant?.featured_image?.id || '');
        const mediaAlt = normalizeCaseMediaAlt(variant?.featured_media?.alt || variant?.featured_image?.alt || variant?.name || '');
        const imageWidths = getGalleryImageWidths(visibleImages[0]);
        const previewRatio =
          Number(previewImage?.aspect_ratio || 0) ||
          (
            Number(previewImage?.width || 0) > 0 &&
            Number(previewImage?.height || 0) > 0
              ? Number(previewImage.width) / Number(previewImage.height)
              : 0
          );

        visibleImages.forEach((image) => {
          updateGalleryImageSource(image, previewSrc, imageWidths);

          if (mediaAlt) {
            image.setAttribute('alt', mediaAlt);
            image.alt = mediaAlt;
          }

          if (previewImage?.width) {
            image.setAttribute('width', String(previewImage.width));
          }

          if (previewImage?.height) {
            image.setAttribute('height', String(previewImage.height));
          }

          const maxResolution = getSizedMediaUrl(previewSrc, 3840);
          if (maxResolution) {
            image.setAttribute('data-max-resolution', maxResolution);
          }
        });

        const slideMediaElement = getSlideMediaElement(currentSlide);
        if (mediaId) {
          currentSlide.setAttribute('data-media-id', mediaId);
          slideMediaElement?.setAttribute('data-media-id', mediaId);
          currentSlide.querySelector('.product-media')?.setAttribute('data-media-id', mediaId);
        }

        if (previewRatio > 0) {
          currentSlide.querySelector('.product-media')?.style.setProperty('--ratio', String(previewRatio));
        }

        const selectedThumbnail =
          gallery.querySelector('.slideshow-controls__thumbnail[aria-selected="true"]') ||
          gallery.querySelector('.slideshow-controls__thumbnail:not([hidden])');

        if (selectedThumbnail instanceof HTMLElement) {
          if (mediaId) {
            selectedThumbnail.setAttribute('data-media-id', mediaId);
            selectedThumbnail.querySelector('[data-media-id]')?.setAttribute('data-media-id', mediaId);
          }

          const thumbnailImage = selectedThumbnail.querySelector('img');
          if (thumbnailImage instanceof HTMLImageElement) {
            updateGalleryImageSource(thumbnailImage, previewSrc, getGalleryImageWidths(thumbnailImage));
            if (mediaAlt) {
              thumbnailImage.setAttribute('alt', mediaAlt);
              thumbnailImage.alt = mediaAlt;
            }
          }
        }

        return true;
      };

      const renderVariantGallery = (variantId) => {
        const normalizedVariantId = String(variantId || '');
        const mediaItems = loadedVariantGalleries.get(normalizedVariantId) || variantMediaMap[normalizedVariantId] || [];
        const media = mediaItems[0];
        if (!media?.src) return false;

        loadedVariantGalleries.set(normalizedVariantId, mediaItems);

        const gallery = getMediaGallery();
        const slideshow = gallery?.slideshow;
        const slide =
          slideshow?.slides?.[slideshow.current] ||
          gallery?.querySelector('slideshow-slide:not([hidden])') ||
          gallery?.querySelector('slideshow-slide');
        if (!(slide instanceof HTMLElement)) return false;

        slide.querySelectorAll('img').forEach((image) => {
          if (!(image instanceof HTMLImageElement)) return;
          updateGalleryImageSource(image, media.src, getGalleryImageWidths(image));
          image.loading = 'eager';
          image.decoding = 'async';
          image.fetchPriority = 'high';
          if (media.alt) image.alt = normalizeCaseMediaAlt(media.alt);
          if (media.width) image.setAttribute('width', String(media.width));
          if (media.height) image.setAttribute('height', String(media.height));
        });

        const mediaId = String(media.id || '');
        if (mediaId) {
          slide.setAttribute('data-media-id', mediaId);
          getSlideMediaElement(slide)?.setAttribute('data-media-id', mediaId);
          slide.querySelector('.product-media')?.setAttribute('data-media-id', mediaId);
        }

        const thumbnail = gallery.querySelector('.slideshow-controls__thumbnail[aria-selected="true"]') ||
          gallery.querySelector('.slideshow-controls__thumbnail:not([hidden])');
        const thumbnailImage = thumbnail?.querySelector('img');
        if (thumbnailImage instanceof HTMLImageElement) {
          updateGalleryImageSource(thumbnailImage, media.src, getGalleryImageWidths(thumbnailImage));
          thumbnailImage.alt = normalizeCaseMediaAlt(media.alt || '');
          if (mediaId) {
            thumbnail.setAttribute('data-media-id', mediaId);
            thumbnail.querySelector('[data-media-id]')?.setAttribute('data-media-id', mediaId);
          }
        }

        gallery?.setAttribute('data-gc-current-variant-id', normalizedVariantId);
        setMediaGalleryFilterPending(false);
        return true;
      };

      if (root.dataset.gcVariantMediaListenerBound !== 'true') {
        document.addEventListener('gc:product-variant-change', (event) => {
          if (!root.isConnected) return;
          const detail = event.detail || {};
          if (String(detail.productId || '') !== String(root.dataset.productId || '')) return;
          renderVariantGallery(detail.variantId);
        });
        root.dataset.gcVariantMediaListenerBound = 'true';
      }

      const getSlideMediaElement = (slide) => {
        if (!(slide instanceof HTMLElement)) return null;
        return (
          slide.querySelector?.('[data-media-id]') ||
          null
        );
      };

      const getGalleryStateSnapshot = (gallery) => {
        if (!gallery) return null;

        const slideshow = gallery.slideshow;
        const slides = Array.from(slideshow?.refs?.slides || []);
        const currentSlide = slideshow?.slides?.[slideshow.current];
        const currentSlideMediaId =
          currentSlide?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
          currentSlide?.getAttribute?.('data-media-id') ||
          '';

        return {
          visible:
            gallery.getBoundingClientRect().width > 0 &&
            gallery.getBoundingClientRect().height > 0 &&
            window.getComputedStyle(gallery).display !== 'none' &&
            window.getComputedStyle(gallery).visibility !== 'hidden',
          rect: {
            x: Math.round(gallery.getBoundingClientRect().x),
            y: Math.round(gallery.getBoundingClientRect().y),
            width: Math.round(gallery.getBoundingClientRect().width),
            height: Math.round(gallery.getBoundingClientRect().height),
          },
          hasSlideshow: Boolean(slideshow),
          slideCount: slides.length,
          currentIndex: slideshow?.current ?? null,
          currentSlideMediaId,
          classes: gallery.className,
        };
      };

      const isGalleryThumbnailVisible = (thumbnail) => {
        return thumbnail instanceof HTMLElement
          && !thumbnail.hidden
          && thumbnail.getAttribute('aria-hidden') !== 'true'
          && thumbnail.dataset.gcMediaHidden !== 'true';
      };

      const scrollGalleryThumbnailRailToTarget = (targetThumbnail) => {
        if (!(targetThumbnail instanceof HTMLElement)) return;

        const rail = targetThumbnail.closest('.slideshow-controls__thumbnails-container, .slideshow-controls__thumbnails, .gc-thumbnail-controls, .media-gallery__mobile-controls[thumbnails]');
        if (!(rail instanceof HTMLElement) || rail.scrollWidth <= rail.clientWidth) return;

        const railRect = rail.getBoundingClientRect();
        const thumbRect = targetThumbnail.getBoundingClientRect();
        const nextLeft = rail.scrollLeft + (thumbRect.left - railRect.left) - ((rail.clientWidth - thumbRect.width) / 2);

        rail.scrollTo({
          left: Math.max(0, nextLeft),
          behavior: 'auto'
        });
      };

      const syncGalleryThumbnailSelection = (gallery, targetThumbnail) => {
        if (!gallery) return;

        const thumbnails = Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail'));
        thumbnails.forEach((thumbnail) => {
          if (!(thumbnail instanceof HTMLElement)) return;

          const isTarget = thumbnail === targetThumbnail;
          thumbnail.setAttribute('aria-selected', isTarget ? 'true' : 'false');

          if (isTarget) {
            thumbnail.hidden = false;
            thumbnail.removeAttribute('data-gc-media-hidden');
            thumbnail.setAttribute('aria-hidden', 'false');
            thumbnail.style.removeProperty('display');
          }
        });

        if (targetThumbnail instanceof HTMLElement) {
          scrollGalleryThumbnailRailToTarget(targetThumbnail);
        }
      };

      const ensureGallerySlideInView = (targetSlide) => {
        if (!(targetSlide instanceof HTMLElement)) return;

        targetSlide.setAttribute('aria-hidden', 'false');
      };

      const findGalleryThumbnailForVariant = (gallery, variant, { visibleOnly = true } = {}) => {
        if (!gallery || !variant) return null;

        const thumbnails = Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail'));
        const targetMediaIds = [
          variant?.featured_media?.id,
          variant?.featured_image?.id
        ]
          .filter(Boolean)
          .map((value) => String(value));
        const targetMediaKeys = collectVariantMediaKeys(variant);
        let fallbackThumbnail = null;

        for (const thumbnail of thumbnails) {
          if (!(thumbnail instanceof HTMLElement)) continue;
          if (visibleOnly && !isGalleryThumbnailVisible(thumbnail)) continue;

          const thumbnailMediaId = String(
            thumbnail.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
            thumbnail.getAttribute('data-media-id') ||
            ''
          );

          if (thumbnailMediaId && targetMediaIds.includes(thumbnailMediaId)) {
            return thumbnail;
          }

          if (!fallbackThumbnail && Array.from(collectElementMediaKeys(thumbnail)).some((key) => targetMediaKeys.has(key))) {
            fallbackThumbnail = thumbnail;
          }
        }

        return fallbackThumbnail;
      };

      const findGallerySlideForVariant = (gallery, variant) => {
        if (!gallery || !variant) return null;

        const slideshow = gallery.slideshow;
        const slides = Array.from(slideshow?.refs?.slides || []);
        if (!slides.length) return null;

        const targetMediaIds = [
          variant?.featured_media?.id,
          variant?.featured_image?.id
        ]
          .filter(Boolean)
          .map((value) => String(value));

        const targetMediaKeys = collectVariantMediaKeys(variant);
        let fallbackSlide = null;

        debugMediaSync('syncMediaGalleryToVariant:match-start', {
          variant: getVariantSyncDebugInfo(variant),
          gallery: getGalleryStateSnapshot(gallery),
          targetMediaIds,
          targetMediaKeys: Array.from(targetMediaKeys),
          slideCount: slides.length,
        });

        for (const slide of slides) {
          const mediaElement = getSlideMediaElement(slide);
          if (!mediaElement) continue;

          const mediaId = String(
            mediaElement.getAttribute?.('data-media-id') ||
            slide.getAttribute?.('data-media-id') ||
            ''
          );

          if (mediaId && targetMediaIds.includes(mediaId)) {
            debugMediaSync('syncMediaGalleryToVariant:match-by-id', {
              variant: getVariantSyncDebugInfo(variant),
              mediaId,
              slideIndex: slides.indexOf(slide),
              slideState: {
                hidden: slide.hidden,
                ariaHidden: slide.getAttribute('aria-hidden'),
                slideId: slide.getAttribute('slide-id'),
              },
              mediaElementTag: mediaElement.tagName,
              mediaElementClass: mediaElement.className || '',
            });
            return slide;
          }

          if (!fallbackSlide && Array.from(collectElementMediaKeys(mediaElement)).some((key) => targetMediaKeys.has(key))) {
            fallbackSlide = slide;
            debugMediaSync('syncMediaGalleryToVariant:match-by-key-candidate', {
              variant: getVariantSyncDebugInfo(variant),
              mediaId,
              slideIndex: slides.indexOf(slide),
              slideState: {
                hidden: slide.hidden,
                ariaHidden: slide.getAttribute('aria-hidden'),
                slideId: slide.getAttribute('slide-id'),
              },
              mediaElementTag: mediaElement.tagName,
              mediaElementClass: mediaElement.className || '',
            });
          }
        }

        if (fallbackSlide) {
          debugMediaSync('syncMediaGalleryToVariant:match-by-key-fallback', {
            variant: getVariantSyncDebugInfo(variant),
            slideIndex: slides.indexOf(fallbackSlide),
            slideState: {
              hidden: fallbackSlide.hidden,
              ariaHidden: fallbackSlide.getAttribute('aria-hidden'),
              slideId: fallbackSlide.getAttribute('slide-id'),
            },
          });
        } else {
          debugMediaSync('syncMediaGalleryToVariant:no-slide-match', {
            variant: getVariantSyncDebugInfo(variant),
            targetMediaIds,
            targetMediaKeys: Array.from(targetMediaKeys),
          });
        }

        return fallbackSlide;
      };

      const findGallerySlideForThumbnail = (gallery, thumbnail) => {
        if (!gallery || !(thumbnail instanceof HTMLElement)) return null;

        const slideshow = gallery.slideshow;
        const slides = Array.from(slideshow?.refs?.slides || []);
        if (!slides.length) return null;

        const thumbnailMediaId = String(
          thumbnail.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
          thumbnail.getAttribute('data-media-id') ||
          ''
        );
        const thumbnailMediaKeys = collectElementMediaKeys(thumbnail);
        let fallbackSlide = null;

        for (const slide of slides) {
          const mediaElement = getSlideMediaElement(slide);
          if (!mediaElement) continue;

          const slideMediaId = String(
            mediaElement.getAttribute?.('data-media-id') ||
            slide.getAttribute?.('data-media-id') ||
            ''
          );

          if (thumbnailMediaId && slideMediaId === thumbnailMediaId) {
            return slide;
          }

          if (!fallbackSlide && Array.from(collectElementMediaKeys(mediaElement)).some((key) => thumbnailMediaKeys.has(key))) {
            fallbackSlide = slide;
          }
        }

        return fallbackSlide;
      };

      const selectGallerySlide = (gallery, targetSlide, targetThumbnail = null) => {
        const slideshow = gallery?.slideshow;
        if (!gallery || !slideshow?.select || !(targetSlide instanceof HTMLElement)) return false;

        ensureGallerySlideInView(targetSlide);

        const currentSlide = slideshow.slides?.[slideshow.current];
        if (currentSlide === targetSlide) {
          if (targetThumbnail instanceof HTMLElement) {
            syncGalleryThumbnailSelection(gallery, targetThumbnail);
          }
          return true;
        }

        const visibleSlides = slideshow.slides || [];
        const targetIndex = visibleSlides.indexOf(targetSlide);
        if (targetIndex < 0) return false;

        const targetSlideId = targetSlide.getAttribute('slide-id');
        if (targetSlideId) {
          slideshow.select({ id: targetSlideId }, undefined, { animate: false });
        } else {
          slideshow.select(targetIndex, undefined, { animate: false });
        }

        window.requestAnimationFrame(() => {
          if (targetThumbnail instanceof HTMLElement) {
            syncGalleryThumbnailSelection(gallery, targetThumbnail);
          }
        });

        return true;
      };

      const applyGalleryThumbnailSelection = (event, thumbnail) => {
        if (!(thumbnail instanceof HTMLElement) || !isGalleryThumbnailVisible(thumbnail)) return false;

        const gallery = thumbnail.closest('media-gallery');
        if (!(gallery instanceof HTMLElement) || !root.contains(gallery)) return false;

        const targetSlide = findGallerySlideForThumbnail(gallery, thumbnail);
        if (!(targetSlide instanceof HTMLElement)) return false;

        event.stopImmediatePropagation();
        event.preventDefault();
        event.stopPropagation();

        if (selectGallerySlide(gallery, targetSlide, thumbnail)) {
          const variant = activeMediaGalleryFilterVariant || getCurrentVariantFromForm();
          manualGallerySelection = {
            variantId: variant?.id ? String(variant.id) : '',
            mediaKeys: Array.from(collectElementMediaKeys(thumbnail)),
          };
          return true;
        }

        return false;
      };

      const handleGalleryThumbnailClick = (event) => {
        if (Date.now() - lastHandledGalleryThumbnailTapAt < 600) {
          event.stopImmediatePropagation();
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const thumbnail = event.currentTarget;
        applyGalleryThumbnailSelection(event, thumbnail);
      };

      const getGalleryThumbnailEventPoint = (event) => {
        const touch = event?.changedTouches?.[0] || event?.touches?.[0];
        if (touch) {
          return {
            x: touch.clientX,
            y: touch.clientY,
          };
        }

        if (typeof event?.clientX === 'number' && typeof event?.clientY === 'number') {
          return {
            x: event.clientX,
            y: event.clientY,
          };
        }

        return null;
      };

      const beginGalleryThumbnailTap = (event) => {
        const thumbnail = event.currentTarget;
        if (!(thumbnail instanceof HTMLElement) || !isGalleryThumbnailVisible(thumbnail)) {
          activeGalleryThumbnailTap = null;
          return;
        }

        const point = getGalleryThumbnailEventPoint(event);
        activeGalleryThumbnailTap = {
          thumbnail,
          x: point?.x ?? null,
          y: point?.y ?? null,
        };
      };

      const clearGalleryThumbnailTap = () => {
        activeGalleryThumbnailTap = null;
      };

      const handleGalleryThumbnailPointerUp = (event) => {
        const thumbnail = event.currentTarget;
        if (!(thumbnail instanceof HTMLElement) || !isGalleryThumbnailVisible(thumbnail)) {
          clearGalleryThumbnailTap();
          return;
        }

        const point = getGalleryThumbnailEventPoint(event);
        const activeTap = activeGalleryThumbnailTap;
        clearGalleryThumbnailTap();

        if (!activeTap || activeTap.thumbnail !== thumbnail) return;

        if (
          point &&
          activeTap.x !== null &&
          activeTap.y !== null &&
          Math.hypot(point.x - activeTap.x, point.y - activeTap.y) > galleryThumbnailTapMaxDistance
        ) {
          return;
        }

        if (applyGalleryThumbnailSelection(event, thumbnail)) {
          lastHandledGalleryThumbnailTapAt = Date.now();
        }
      };

      const bindGalleryThumbnailControls = (gallery) => {
        if (!gallery) return;

        gallery.querySelectorAll('.slideshow-controls__thumbnail').forEach((thumbnail) => {
          if (!(thumbnail instanceof HTMLElement) || thumbnail.dataset.gcThumbClickBound === 'true') return;

          thumbnail.style.touchAction = 'manipulation';
          thumbnail.addEventListener('pointerdown', beginGalleryThumbnailTap, true);
          thumbnail.addEventListener('click', handleGalleryThumbnailClick, true);
          thumbnail.addEventListener('pointerup', handleGalleryThumbnailPointerUp, true);
          thumbnail.addEventListener('pointercancel', clearGalleryThumbnailTap, true);
          thumbnail.addEventListener('touchstart', beginGalleryThumbnailTap, { capture: true, passive: true });
          thumbnail.addEventListener('touchend', handleGalleryThumbnailPointerUp, { capture: true, passive: false });
          thumbnail.addEventListener('touchcancel', clearGalleryThumbnailTap, true);
          thumbnail.dataset.gcThumbClickBound = 'true';
        });
      };

      const findManualGalleryThumbnailForVariant = (gallery, variant) => {
        if (!gallery || !variant || !manualGallerySelection) return null;
        if (manualGallerySelection.variantId !== String(variant.id)) return null;

        return Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail')).find((thumbnail) => {
          if (!isGalleryThumbnailVisible(thumbnail)) return false;
          return Array.from(collectElementMediaKeys(thumbnail)).some((key) => manualGallerySelection.mediaKeys.includes(key));
        }) || null;
      };

      function scheduleMediaGallerySyncRetry(variant, token, retryAttempt) {
        const retryDelay = mediaGallerySyncRetryDelays[retryAttempt];
        if (!retryDelay) return;

        window.setTimeout(() => {
          if (token !== mediaGallerySyncToken) {
            return;
          }

          syncMediaGalleryToVariant(variant, token, retryAttempt + 1);
        }, retryDelay);
      }

      const syncMediaGalleryToVariant = (variant, token = null, retryAttempt = 0) => {
        if (token === null) {
          token = ++mediaGallerySyncToken;
        } else if (token !== mediaGallerySyncToken) {
          return token;
        }

        const targetMediaIds = [
          variant?.featured_media?.id,
          variant?.featured_image?.id,
        ]
          .filter(Boolean)
          .map((value) => String(value));

        debugMediaSync('syncMediaGalleryToVariant:start', {
          token,
          currentToken: mediaGallerySyncToken,
          variant: getVariantSyncDebugInfo(variant),
          galleries: getMediaGalleryDebugInfo(),
        });

        if (!variant) {
          setMediaGalleryFilterPending(false);
          debugMediaSync('syncMediaGalleryToVariant:abort-no-variant', { token });
          return token;
        }

        const gallery = getMediaGallery();
        const slideshow = gallery?.slideshow;
        bindGalleryThumbnailControls(gallery);
        debugMediaSync('syncMediaGalleryToVariant:gallery-choice', {
          token,
          chosenGallery: getGalleryStateSnapshot(gallery),
          hasGallery: Boolean(gallery),
          hasSlideshow: Boolean(slideshow),
          hasSelect: Boolean(slideshow?.select),
        });

        if (!gallery || !slideshow?.select) {
          if (targetMediaIds.length && retryAttempt < mediaGallerySyncRetryDelays.length) {
            scheduleMediaGallerySyncRetry(variant, token, retryAttempt);
          }
          debugMediaSync('syncMediaGalleryToVariant:abort-no-gallery-or-slideshow', { token });
          return token;
        }

        const targetSlide = findGallerySlideForVariant(gallery, variant);
        if (!targetSlide) {
          if (targetMediaIds.length && retryAttempt < mediaGallerySyncRetryDelays.length) {
            scheduleMediaGallerySyncRetry(variant, token, retryAttempt);
          }
          debugMediaSync('syncMediaGalleryToVariant:abort-no-target-slide', {
            token,
            variant: getVariantSyncDebugInfo(variant),
            gallery: getGalleryStateSnapshot(gallery),
          });
          return token;
        }

        const slides = Array.from(slideshow.refs?.slides || []);
        const targetIndex = slides.indexOf(targetSlide);
        if (targetIndex < 0) {
          if (targetMediaIds.length && retryAttempt < mediaGallerySyncRetryDelays.length) {
            scheduleMediaGallerySyncRetry(variant, token, retryAttempt);
          }
          debugMediaSync('syncMediaGalleryToVariant:abort-target-index-negative', {
            token,
            variant: getVariantSyncDebugInfo(variant),
            gallery: getGalleryStateSnapshot(gallery),
            targetSlideState: {
              hidden: targetSlide.hidden,
              ariaHidden: targetSlide.getAttribute('aria-hidden'),
              slideId: targetSlide.getAttribute('slide-id'),
            },
          });
          return token;
        }

        if (targetSlide.hidden) {
          targetSlide.hidden = false;
          targetSlide.removeAttribute('data-gc-media-hidden');
          targetSlide.setAttribute('reveal', '');
          targetSlide.setAttribute('aria-hidden', 'false');
          debugMediaSync('syncMediaGalleryToVariant:unhide-target-slide', {
            token,
            targetIndex,
            targetSlideState: {
              hidden: targetSlide.hidden,
              ariaHidden: targetSlide.getAttribute('aria-hidden'),
              slideId: targetSlide.getAttribute('slide-id'),
            },
          });
        }

        const currentSlide = slideshow.slides?.[slideshow.current];
        const targetThumbnail =
          findGalleryThumbnailForVariant(gallery, variant) ||
          findGalleryThumbnailForVariant(gallery, variant, { visibleOnly: false });

        if (currentSlide === targetSlide) {
          if (targetThumbnail) {
            syncGalleryThumbnailSelection(gallery, targetThumbnail);
          }
          debugMediaSync('syncMediaGalleryToVariant:already-current', {
            token,
            targetIndex,
            currentIndex: slideshow.current,
            currentSlideMediaId:
              currentSlide?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
              currentSlide?.getAttribute?.('data-media-id') ||
              '',
          });
          return token;
        }

        const visibleSlides = slideshow.slides || [];
        const visibleIndex = visibleSlides.indexOf(targetSlide);
        if (visibleIndex < 0) {
          debugMediaSync('syncMediaGalleryToVariant:abort-visible-index-negative', {
            token,
            targetIndex,
            visibleSlidesCount: visibleSlides.length,
          });
          return token;
        }

        debugMediaSync('syncMediaGalleryToVariant:select-before', {
          token,
          targetIndex,
          visibleIndex,
          currentIndex: slideshow.current,
          currentSlideMediaId:
            currentSlide?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
            currentSlide?.getAttribute?.('data-media-id') ||
            '',
          targetSlideState: {
            hidden: targetSlide.hidden,
            ariaHidden: targetSlide.getAttribute('aria-hidden'),
            slideId: targetSlide.getAttribute('slide-id'),
          },
          targetMediaId:
            targetSlide.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
            targetSlide.getAttribute?.('data-media-id') ||
            '',
        });

        window.requestAnimationFrame(() => {
          if (token !== mediaGallerySyncToken) {
            debugMediaSync('syncMediaGalleryToVariant:skip-stale-token', {
              token,
              currentToken: mediaGallerySyncToken,
            });
            return;
          }

          slideshow.select(visibleIndex, undefined, { animate: false });

          window.requestAnimationFrame(() => {
            const postCurrentSlide = slideshow.slides?.[slideshow.current];
            if (targetThumbnail) {
              syncGalleryThumbnailSelection(gallery, targetThumbnail);
            }
            debugMediaSync('syncMediaGalleryToVariant:select-after', {
              token,
              currentIndex: slideshow.current,
              currentSlideMediaId:
                postCurrentSlide?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
                postCurrentSlide?.getAttribute?.('data-media-id') ||
                '',
              activeThumbnail:
                Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail'))
                  .find((thumbnail) => thumbnail instanceof HTMLElement && thumbnail.getAttribute('aria-selected') === 'true')
                  ?.querySelector?.('[data-media-id]')?.getAttribute('data-media-id') ||
                '',
              gallery: getGalleryStateSnapshot(gallery),
            });
          });
        });

        return token;
      };

      const filterMediaGalleryForVariantModel = (variant) => {
        const gallery = root.querySelector('.gc-hero-image-wrap media-gallery');
        if (!gallery || !variant) {
          setMediaGalleryFilterPending(false);
          return;
        }

        const targetModel = getVariantModel(variant);
        if (!targetModel) {
          setMediaGalleryFilterPending(false);
          return;
        }

        const targetMediaKeys = new Set();
        variants
          .filter((candidate) => normalizeModel(getVariantModel(candidate)) === targetModel)
          .forEach((candidate) => {
            collectVariantMediaKeys(candidate).forEach((key) => targetMediaKeys.add(key));
          });

        if (!targetMediaKeys.size) {
          setMediaGalleryFilterPending(false);
          return;
        }

        const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
        const thumbnails = Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail'));
        bindGalleryThumbnailControls(gallery);
        const slideVisibility = slides.map((slide) => {
          return Array.from(collectElementMediaKeys(slide)).some((key) => targetMediaKeys.has(key));
        });
        const thumbnailVisibility = thumbnails.map((thumbnail) => {
          return Array.from(collectElementMediaKeys(thumbnail)).some((key) => targetMediaKeys.has(key));
        });

        if (!slideVisibility.some(Boolean) && !thumbnailVisibility.some(Boolean)) {
          slides.forEach((slide) => {
            slide.hidden = false;
            slide.removeAttribute('data-gc-media-hidden');
            slide.style.removeProperty('display');
          });

          thumbnails.forEach((thumbnail) => {
            if (!(thumbnail instanceof HTMLElement)) return;
            thumbnail.hidden = false;
            thumbnail.removeAttribute('data-gc-media-hidden');
            thumbnail.style.removeProperty('display');
            thumbnail.setAttribute('aria-hidden', 'false');
          });

          setMediaGalleryFilterPending(false);
          return;
        }

        let firstVisibleThumbnail = null;

        slides.forEach((slide, index) => {
          const shouldShow = slideVisibility[index];
          slide.hidden = !shouldShow;
          if (shouldShow) {
            slide.removeAttribute('data-gc-media-hidden');
            slide.style.removeProperty('display');
          } else {
            slide.setAttribute('data-gc-media-hidden', 'true');
            slide.style.setProperty('display', 'none', 'important');
          }
        });

        thumbnails.forEach((thumbnail, index) => {
          if (thumbnail instanceof HTMLElement) {
            const shouldShow = thumbnailVisibility[index];
            thumbnail.hidden = !shouldShow;
            if (shouldShow) {
              thumbnail.removeAttribute('data-gc-media-hidden');
              thumbnail.style.removeProperty('display');
            } else {
              thumbnail.setAttribute('data-gc-media-hidden', 'true');
              thumbnail.style.setProperty('display', 'none', 'important');
            }
            thumbnail.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

            if (shouldShow && firstVisibleThumbnail === null) {
              firstVisibleThumbnail = thumbnail;
            }
          }
        });

        const manualThumbnail = findManualGalleryThumbnailForVariant(gallery, variant);
        if (manualThumbnail instanceof HTMLElement) {
          const manualSlide = findGallerySlideForThumbnail(gallery, manualThumbnail);
          if (manualSlide instanceof HTMLElement) {
            selectGallerySlide(gallery, manualSlide, manualThumbnail);
          } else {
            syncGalleryThumbnailSelection(gallery, manualThumbnail);
          }
          setMediaGalleryFilterPending(false);
          return;
        }

        const selectedMediaKeys = collectVariantMediaKeys(variant);
        const currentSlide = gallery.slideshow?.slides?.[gallery.slideshow.current];
        const currentSlideMatchesVariant = currentSlide
          && Array.from(collectElementMediaKeys(currentSlide)).some((key) => selectedMediaKeys.has(key));
        const activeVisibleThumbnail = thumbnails.find((thumbnail) => {
          return isGalleryThumbnailVisible(thumbnail)
            && thumbnail.getAttribute('aria-selected') === 'true';
        });
        const activeVisibleThumbnailMatchesVariant = activeVisibleThumbnail
          && Array.from(collectElementMediaKeys(activeVisibleThumbnail)).some((key) => selectedMediaKeys.has(key));

        const selectedThumbnail = thumbnails.find((thumbnail) => {
          if (!isGalleryThumbnailVisible(thumbnail)) return false;
          return Array.from(collectElementMediaKeys(thumbnail)).some((key) => selectedMediaKeys.has(key));
        });

        if (activeVisibleThumbnailMatchesVariant && currentSlideMatchesVariant) {
          setMediaGalleryFilterPending(false);
          return;
        }

        if (selectedThumbnail instanceof HTMLElement) {
          const selectedSlide = findGallerySlideForThumbnail(gallery, selectedThumbnail);
          if (selectedSlide instanceof HTMLElement) {
            selectGallerySlide(gallery, selectedSlide, selectedThumbnail);
          } else {
            syncGalleryThumbnailSelection(gallery, selectedThumbnail);
          }
        } else if (firstVisibleThumbnail instanceof HTMLElement) {
          const firstVisibleSlide = findGallerySlideForThumbnail(gallery, firstVisibleThumbnail);
          if (firstVisibleSlide instanceof HTMLElement) {
            selectGallerySlide(gallery, firstVisibleSlide, firstVisibleThumbnail);
          } else {
            syncGalleryThumbnailSelection(gallery, firstVisibleThumbnail);
          }
        }

        setMediaGalleryFilterPending(false);
      };

      const scheduleMediaGalleryVariantFilter = (variant) => {
        if (!variant) return;
        activeMediaGalleryFilterVariant = variant;
        if (mediaGalleryFilterTimer) {
          window.clearTimeout(mediaGalleryFilterTimer);
        }

        mediaGalleryFilterTimer = window.setTimeout(() => {
          mediaGalleryFilterTimer = 0;

          if (activeMediaGalleryFilterVariant !== variant) return;

          filterMediaGalleryForVariantModel(variant);
          if (manualGallerySelection && manualGallerySelection.variantId === String(variant.id)) {
            return;
          }
          syncMediaGalleryToVariant(variant);
        }, 120);
      };

      const bindMediaGalleryFilterObserver = () => {
        if (getMediaGalleryWrap()?.dataset.gcVariantGallery === 'single') return;
        if (mediaGalleryObserver || typeof MutationObserver !== 'function') return;

        const galleryWrap = getMediaGalleryWrap();
        if (!galleryWrap) return;

        mediaGalleryObserver = new MutationObserver((mutations) => {
          const hasNodeChanges = mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length);
          if (!hasNodeChanges) return;

          if (mediaGalleryObserverFrame) {
            window.cancelAnimationFrame(mediaGalleryObserverFrame);
          }

          mediaGalleryObserverFrame = window.requestAnimationFrame(() => {
            mediaGalleryObserverFrame = 0;
            const variant = activeMediaGalleryFilterVariant || getCurrentVariantFromForm();
            if (variant) scheduleMediaGalleryVariantFilter(variant);
          });
        });

        mediaGalleryObserver.observe(galleryWrap, {
          childList: true,
          subtree: true
        });
      };

      const updatePersonalizeButtonHref = (selection = {}) => {
        const targetUrl = new URL(config.personalizeUrl, window.location.origin);
        const brand = selection.brand || '';
        const model = normalizeModel(selection.model || '');
        const finish = normalizeFinish(selection.finish || '');
        const caseKey =
          normalizeCaseKey(selection.caseKey || '') ||
          incomingSelection.caseKey ||
          normalizeCaseKey(config.personalizeCaseKey);

        if (brand) {
          targetUrl.searchParams.set('device', brand.toLowerCase() === 'samsung' ? 'samsung' : 'iphone');
        }

        if (model) targetUrl.searchParams.set('model', model);
        if (finish) targetUrl.searchParams.set('finish', finish);
        if (caseKey) targetUrl.searchParams.set('case', caseKey);
        const href = `${targetUrl.pathname}${targetUrl.search}`;

        if (personalizeButton instanceof HTMLAnchorElement) {
          personalizeButton.setAttribute('href', href);
        }
      };

      const renderBrandButtons = (brands, selectedBrand, onClick) => {
        const existingBrands = Array.from(brandButtonsWrap.querySelectorAll('.gc-brand-tab'))
          .map((button) => button.dataset.gcBrand || '');
        const listChanged = existingBrands.length !== brands.length ||
          brands.some((brand, index) => existingBrands[index] !== brand);

        if (listChanged) {
          brandButtonsWrap.innerHTML = '';
          brands.forEach((brand) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'gc-brand-tab';
            btn.dataset.gcBrand = brand;
            btn.textContent = brand === 'Samsung' ? 'Samsung' : 'iPhone';
            btn.addEventListener('click', () => onClick(brand));
            brandButtonsWrap.appendChild(btn);
          });
        }

        brandButtonsWrap.querySelectorAll('.gc-brand-tab').forEach((button) => {
          button.classList.toggle('active', button.dataset.gcBrand === selectedBrand);
          button.setAttribute('aria-pressed', String(button.dataset.gcBrand === selectedBrand));
        });
      };

      const schedulePaymentButtonStateSync = () => {
        if (paymentStateFrame) return;
        paymentStateFrame = window.requestAnimationFrame(() => {
          paymentStateFrame = 0;
          syncPaymentButtonState();
        });
      };

      const boot = () => {
      const variantArea = findVariantArea();
      if (!variantArea) {
        notifyStickyReady();
        clearBootingState();
        return false;
      }

      const selectRoots = [findVariantArea(), detailsCard, getForm()].filter(Boolean);
      const allSelects = [];
      const seenSelects = new Set();

      selectRoots.forEach((rootNode) => {
        rootNode.querySelectorAll('select').forEach((select) => {
          if (seenSelects.has(select)) return;
          if (select.closest('[data-gc-brand-model-ui]')) return;
          seenSelects.add(select);
          allSelects.push(select);
        });
      });

      if (allSelects.length < 1) {
        restoreNativeVariantUi(variantArea);
        notifyStickyReady();
        clearBootingState();
        return false;
      }

      const findLabelText = (select) => {
        const id = select.id;
        let label = null;

        if (id) {
          label = detailsCard.querySelector(`label[for="${id}"]`);
        }

        if (!label) {
          const inputWrap = select.closest('.product-form__input');
          if (inputWrap) label = inputWrap.querySelector('label');
        }

        return (label?.textContent || '').toLowerCase().trim();
      };

      const getSelectHints = (select) => {
        const dataOptionName = normalizeText(
          select.getAttribute('data-option-name') ||
            select.dataset.optionName ||
            select.dataset.name ||
            ''
        ).toLowerCase();
        const ariaLabel = normalizeText(select.getAttribute('aria-label') || '').toLowerCase();
        const name = normalizeText(select.getAttribute('name') || '').toLowerCase();
        const id = normalizeText(select.id || '').toLowerCase();
        const labelText = findLabelText(select);

        return [dataOptionName, ariaLabel, name, id, labelText].filter(Boolean).join(' ');
      };

      const isModelLikeOptionName = (value) => {
        return value.includes('model') || value.includes('size') || value.includes('device') || value.includes('phone');
      };

      const isFinishLikeOptionName = (value) => {
        return value.includes('finish') || value.includes('surface') || value.includes('material') || value.includes('style');
      };

      const getOptionNameByPositionHint = (select) => {
        const rawPosition =
          select.dataset.optionPosition ||
          select.getAttribute('data-option-position') ||
          select.dataset.index ||
          '';
        const parsedPosition = Number.parseInt(String(rawPosition), 10);
        if (!Number.isFinite(parsedPosition) || parsedPosition < 1) return '';
        return productOptionNames[parsedPosition - 1] || '';
      };

      const modelSelectNative = allSelects.find((select) => {
        const hints = getSelectHints(select);
        const optionNameByPosition = getOptionNameByPositionHint(select);

        return (
          isModelLikeOptionName(optionNameByPosition) ||
          hints.includes('size') ||
          hints.includes('model') ||
          hints.includes('device') ||
          hints.includes('phone') ||
          Array.from(select.options).some((opt) => {
            const val = getOptionText(opt).toLowerCase();
            return val.includes('iphone') || val.includes('galaxy') || val.includes('samsung');
          })
        );
      });

      const finishSelectNative = allSelects.find((select) => {
        if (select === modelSelectNative) return false;
        const hints = getSelectHints(select);
        const optionNameByPosition = getOptionNameByPositionHint(select);

        return (
          isFinishLikeOptionName(optionNameByPosition) ||
          hints.includes('surface') ||
          hints.includes('finish') ||
          hints.includes('material') ||
          hints.includes('style') ||
          Array.from(select.options).some((opt) => {
            const val = getOptionText(opt).toLowerCase();
            return val.includes('glossy') || val.includes('matte');
          })
        );
      });

      if (!modelSelectNative) {
        restoreNativeVariantUi(variantArea);
        notifyStickyReady();
        clearBootingState();
        return false;
      }

      const getSelectedModelOption = () => modelSelectNative.selectedOptions?.[0] || { value: modelSelectNative.value };

      const getNativeModelOptionForBrand = (brand, preferredModel = '') => {
        const normalizedPreferredModel = normalizeModel(preferredModel);
        const options = Array.from(modelSelectNative.options);

        return (
          options.find((opt) => {
            return normalizedPreferredModel && normalizeModel(getOptionText(opt)) === normalizedPreferredModel;
          }) ||
          options.find((opt) => getBrand(normalizeModel(getOptionText(opt))) === brand) ||
          null
        );
      };

      const getNativeModelOption = (modelValue) => {
        const normalizedModel = normalizeModel(modelValue);
        if (!normalizedModel) return null;

        return Array.from(modelSelectNative.options).find((option) => {
          return normalizeModel(getOptionText(option)) === normalizedModel;
        }) || null;
      };

      // A saved phone is the site-wide default, never an override for an explicit
      // product link or a consumed entry context. Do not persist hydration.
      if (!incomingSelection.variantId && !pageParams.get('model') &&
          !incomingSelection.model && incomingSelection.source !== 'entry-context') {
        try {
          const savedModel = normalizeModel(window.localStorage.getItem(selectedPhoneModelStorageKey) || '');
          const savedBrand = getBrand(savedModel);
          if (savedModel && (savedBrand === 'iPhone' || savedBrand === 'Samsung')) {
            incomingSelection.model = savedModel;
            incomingSelection.brand = savedBrand;
          }
        } catch (error) { /* The existing page defaults work without storage. */ }
      }

      const requestedModelFromContext = normalizeModel(pageParams.get('model') || incomingSelection.model || '');
      const requestedModelOption = getNativeModelOption(requestedModelFromContext);
      const requestedVariant = variants.find(
        (variant) => String(variant.id) === incomingSelection.variantId
      ) || null;

      // First-load resolver for standard product pages:
      // Explicit variant > explicit model/entry context > saved phone > page default.
      // Unsupported saved phones use the same purchase guard as explicit models.
      if (requestedVariant) {
        const variantModel = normalizeModel(getVariantModel(requestedVariant));
        const variantFinish = normalizeFinish(getVariantFinish(requestedVariant));
        if (variantModel) {
          incomingSelection.model = variantModel;
          incomingSelection.brand = getBrand(variantModel);
        }
        if (variantFinish) {
          incomingSelection.finish = variantFinish;
        }
      } else if (requestedModelOption) {
        incomingSelection.model = normalizeModel(getOptionText(requestedModelOption));
        incomingSelection.brand = getBrand(incomingSelection.model);
      } else if (requestedModelFromContext && !getNativeModelOption(requestedModelFromContext)) {
        unavailableRequestedModel = requestedModelFromContext;
        incomingSelection.model = requestedModelFromContext;
        incomingSelection.brand = getBrand(requestedModelFromContext);
      }

      const sanitizeMismatchedVariantContext = () => {
        if (unavailableRequestedModel) return;
        const requestedBrand = incomingSelection.brand || getCollectionContextBrand() || productTitleBrand;
        if (requestedBrand !== 'Samsung' && requestedBrand !== 'iPhone') return;

        const incomingVariant = variants.find((variant) => String(variant.id) === incomingSelection.variantId);
        const incomingVariantBrand = incomingVariant
          ? getBrand(
              [incomingVariant.option1, incomingVariant.option2, incomingVariant.option3]
                .map((value) => normalizeModel(value))
                .find((value) => {
                  const brand = getBrand(value);
                  return brand === 'Samsung' || brand === 'iPhone';
                }) || ''
            )
          : 'Other';

        const sanitizedUrl = new URL(window.location.href);
        const shouldDropIncomingVariant =
          Boolean(incomingSelection.variantId) &&
          (
            !incomingVariant ||
            (incomingVariantBrand !== 'Other' && incomingVariantBrand !== requestedBrand)
          );

        const currentModelOption = getSelectedModelOption();
        const currentModel = normalizeModel(getOptionText(currentModelOption));
        const currentBrand = getBrand(currentModel);
        if (currentBrand === requestedBrand) {
          if (shouldDropIncomingVariant && sanitizedUrl.searchParams.has('variant')) {
            sanitizedUrl.searchParams.delete('variant');
            history.replaceState({}, '', sanitizedUrl.toString());
          }
          if (shouldDropIncomingVariant) {
            incomingSelection.variantId = '';
          }
          return;
        }

        const replacementOption = getNativeModelOptionForBrand(requestedBrand, incomingSelection.model);
        if (!replacementOption) {
          if (shouldDropIncomingVariant && sanitizedUrl.searchParams.has('variant')) {
            sanitizedUrl.searchParams.delete('variant');
            window.location.replace(sanitizedUrl.toString());
          }
          if (shouldDropIncomingVariant) {
            incomingSelection.variantId = '';
          }
          return;
        }

        incomingSelection.model = incomingSelection.model || incomingSelection.variantId
          ? normalizeModel(getOptionText(replacementOption))
          : '';
        incomingSelection.variantId = '';

        if (sanitizedUrl.searchParams.has('variant')) {
          sanitizedUrl.searchParams.delete('variant');
          history.replaceState({}, '', sanitizedUrl.toString());
        }
      };

      sanitizeMismatchedVariantContext();

      const getCurrentModelText = () => {
        return normalizeModel(
          getOptionText(getSelectedModelOption())
        );
      };

      const getCurrentFinishText = () => {
        if (!finishSelectNative) return '';

        return normalizeFinish(
          getOptionText(finishSelectNative.selectedOptions?.[0] || { value: finishSelectNative.value })
        );
      };

      const getNativeStateKey = () => {
        return [getCurrentVariantId(), getCurrentModelText(), getCurrentFinishText()].join('|');
      };

      const scheduleRefreshUiFromNative = () => {
        if (refreshUiFrame) return;

        refreshUiFrame = window.requestAnimationFrame(() => {
          refreshUiFrame = 0;
          const nextState = getNativeStateKey();
          if (nextState === lastRenderedNativeState) return;
          refreshUiFromNative();
        });
      };

      const getResolvedBrandPreference = () => {
        if (
          (incomingSelection.variantId || incomingSelection.model) &&
          (incomingSelection.brand === 'Samsung' || incomingSelection.brand === 'iPhone')
        ) {
          return incomingSelection.brand;
        }

        const collectionBrand = getCollectionContextBrand();
        if (collectionBrand === 'Samsung' || collectionBrand === 'iPhone') {
          return collectionBrand;
        }

        if (productTitleBrand === 'Samsung' || productTitleBrand === 'iPhone') {
          return productTitleBrand;
        }

        // 双品牌商品（标题无品牌词）且无显式变体/机型入参时默认 iPhone，
        // 与服务端 Liquid 的品牌对齐规则保持一致；?variant= 深链不受影响。
        if (!incomingSelection.variantId && !incomingSelection.model) {
          const hasIphoneModels = Array.from(modelSelectNative.options).some(
            (opt) => getBrand(normalizeModel(getOptionText(opt))) === 'iPhone'
          );
          if (hasIphoneModels) return 'iPhone';
        }

        const currentBrand = getBrand(getCurrentModelText());
        if (currentBrand === 'Samsung' || currentBrand === 'iPhone') {
          return currentBrand;
        }

        return '';
      };

      let initialBrandOrderPreference = '';

      const getBrands = () => {
        const models = Array.from(modelSelectNative.options)
          .map((opt) => normalizeModel(getOptionText(opt)))
          .filter(Boolean);

        const brands = Array.from(new Set(models.map(getBrand))).filter((brand) => brand !== 'Other');
        // Freeze the entry-context order once. Switching brands updates only the
        // active state and variant; it must not make the two buttons trade places.
        if (!initialBrandOrderPreference) {
          initialBrandOrderPreference = getResolvedBrandPreference();
        }
        const preferredBrand = initialBrandOrderPreference;
        const ordered = brands.slice();

        if (preferredBrand === 'Samsung') {
          ordered.sort((a, b) => {
            if (a === 'Samsung') return -1;
            if (b === 'Samsung') return 1;
            return 0;
          });
        } else if (preferredBrand === 'iPhone') {
          ordered.sort((a, b) => {
            if (a === 'iPhone') return -1;
            if (b === 'iPhone') return 1;
            return 0;
          });
        }

        return ordered;
      };

      const getModelsForBrand = (brand) => {
        const models = Array.from(modelSelectNative.options)
          .map((opt) => normalizeModel(getOptionText(opt)))
          .filter((model) => getBrand(model) === brand);

        const uniqueModels = Array.from(new Set(models));
        const order = brand === 'Samsung' ? samsungOrder : iphoneOrder;

        return uniqueModels.sort((a, b) => {
          const ia = order.indexOf(a);
          const ib = order.indexOf(b);

          if (ia !== -1 && ib !== -1) return ia - ib;
          if (ia !== -1) return -1;
          if (ib !== -1) return 1;
          return a.localeCompare(b);
        });
      };

      const getDefaultModelForBrand = (brand) => {
        const orderedModels = getModelsForBrand(brand);
        return (
          orderedModels.find((model) => {
            const variant = findVariantForSelection(model);
            return Boolean(variant && variant.available !== false);
          }) ||
          orderedModels[0] ||
          ''
        );
      };

      const getAllFinishNames = () => {
        if (!finishSelectNative) return [];

        return Array.from(
          new Set(
            Array.from(finishSelectNative.options)
              .map((opt) => normalizeFinish(getOptionText(opt)))
              .filter(Boolean)
          )
        );
      };

      const getFinishStatesForModel = (modelValue = '') => {
        const normalizedModel = normalizeModel(modelValue);

        return getAllFinishNames().reduce((states, finishName) => {
          const hasMatchingVariant = Boolean(findVariantForSelection(normalizedModel, finishName));
          if (!hasMatchingVariant) return states;

          states.push({
            value: finishName,
            available: true,
            label: finishName,
          });
          return states;
        }, []);
      };

      const getResolvedFinishForModel = (modelValue = '', requestedFinish = '') => {
        const normalizedRequestedFinish = normalizeFinish(requestedFinish).toLowerCase();
        const finishStates = getFinishStatesForModel(modelValue);

        const requestedState = finishStates.find((state) => {
          return normalizeFinish(state.value).toLowerCase() === normalizedRequestedFinish;
        });
        if (requestedState) return requestedState.value;

        return finishStates[0]?.value || '';
      };

      const setNativeSelectValue = (select, targetText, type = 'model') => {
        if (!select || !targetText) return false;

        const options = Array.from(select.options);
        const normalizedTarget =
          type === 'finish'
            ? normalizeFinish(targetText).toLowerCase()
            : normalizeModel(targetText).toLowerCase();

        const normalizeOption = (opt) => {
          const rawText = getOptionText(opt);
          return type === 'finish'
            ? normalizeFinish(rawText).toLowerCase()
            : normalizeModel(rawText).toLowerCase();
        };

        let matchedOption =
          options.find((opt) => normalizeOption(opt) === normalizedTarget) ||
          options.find((opt) => {
            const rawValue =
              type === 'finish'
                ? normalizeFinish(opt.value).toLowerCase()
                : normalizeModel(opt.value).toLowerCase();
            return rawValue === normalizedTarget;
          });

        if (!matchedOption) return null;

        const matchedIndex = options.indexOf(matchedOption);
        if (select.value === matchedOption.value && select.selectedIndex === matchedIndex) {
          return false;
        }

        options.forEach((opt) => {
          const isMatched = opt === matchedOption;
          opt.selected = isMatched;
          opt.defaultSelected = isMatched;
        });

        select.value = matchedOption.value;
        select.selectedIndex = matchedIndex;
        return true;
      };

      const dispatchNativeChange = (element) => {
        if (!element) return;
        element.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const syncCustomUiSelection = (modelValue, finishValue = '') => {
        const normalizedModel = normalizeModel(modelValue);
        const normalizedFinish = normalizeFinish(finishValue);

        const modelOption = Array.from(modelSelectCustom.options).find((option) => {
          return normalizeModel(option.value) === normalizedModel;
        });
        if (modelOption) modelSelectCustom.value = modelOption.value;

        finishButtonsWrap.querySelectorAll('.gc-finish-btn').forEach((button) => {
          const isActive =
            !button.disabled &&
            normalizeFinish(button.dataset.gcFinish || button.textContent) === normalizedFinish;
          button.classList.toggle('active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
      };

      const persistPhoneSelection = (modelValue) => {
        if (unavailableRequestedModel) return;
        const canonicalModel = normalizeModel(modelValue);
        const modelBrand = getBrand(canonicalModel);
        if (!canonicalModel || (modelBrand !== 'iPhone' && modelBrand !== 'Samsung')) return;

        writePhoneStorage(selectedPhoneBrandStorageKey, modelBrand.toLowerCase());
        writePhoneStorage(selectedPhoneModelStorageKey, canonicalModel);
        root.dispatchEvent(new CustomEvent('gc:phone-model-change', {
          bubbles: true,
          detail: { model: canonicalModel, brand: modelBrand.toLowerCase() }
        }));
      };

      const syncModelSelectionToUrl = (modelValue) => {
        const canonicalModel = normalizeModel(modelValue);
        const modelBrand = getBrand(canonicalModel);
        if (!canonicalModel || (modelBrand !== 'iPhone' && modelBrand !== 'Samsung')) return;

        // Keep explicit legacy URL parameters readable, but do not create new
        // device/model URL variants when a shopper changes the product options.
        const nextUrl = new URL(window.location.href);
        if (nextUrl.searchParams.has('model')) nextUrl.searchParams.set('model', canonicalModel);
        if (nextUrl.searchParams.has('device')) nextUrl.searchParams.set('device', modelBrand.toLowerCase());
        if (nextUrl.href !== window.location.href) window.history.replaceState({}, '', nextUrl);
      };

      const syncToNativeVariant = (modelValue, finishValue = '') => {
        if (!modelValue) return false;

        const modelChanged = setNativeSelectValue(modelSelectNative, modelValue, 'model');
        if (modelChanged === null) return false;

        const requestedFinish = finishSelectNative
          ? normalizeFinish(finishValue || getCurrentFinishText())
          : '';
        const targetFinish = finishSelectNative
          ? getResolvedFinishForModel(modelValue, requestedFinish)
          : '';

        let finishChanged = false;
        if (finishSelectNative && targetFinish) {
          finishChanged = setNativeSelectValue(finishSelectNative, targetFinish, 'finish');
          if (finishChanged === null) return false;
        }

        if (!modelChanged && !finishChanged) {
          scheduleRefreshUiFromNative();
          return false;
        }

        const resolvedVariant = findVariantForSelection(modelValue, targetFinish) || getCurrentVariantFromForm();
        if (resolvedVariant) {
          syncResolvedVariantState(resolvedVariant);
          [modelSelectNative, finishSelectNative].forEach((select) => {
            const selectedOption = select?.selectedOptions?.[0];
            if (selectedOption) selectedOption.dataset.variantId = String(resolvedVariant.id);
          });
          updateCustomPriceDisplay(resolvedVariant);
          updatePersonalizeButtonHref({
            brand: getBrand(modelValue),
            model: normalizeModel(modelValue),
            finish: targetFinish,
            caseKey: config.personalizeCaseKey
          });
        }

        syncCustomUiSelection(modelValue, targetFinish);

        isSyncingVariant = true;

        const dispatchTarget = finishSelectNative && finishChanged ? finishSelectNative : modelSelectNative;
        const variantPicker = dispatchTarget?.closest('variant-picker');
        const shouldBypassNativeFetch = Boolean(resolvedVariant) && !modelChanged;
        if (variantPicker && resolvedVariant && shouldBypassNativeFetch) {
          variantPicker.dataset.gcResolvedVariantId = String(resolvedVariant.id);
        }
        dispatchNativeChange(dispatchTarget);
        if (variantPicker) {
          variantPicker.removeAttribute('data-gc-resolved-variant-id');
        }

        scheduleRefreshUiFromNative();

        window.requestAnimationFrame(() => {
          isSyncingVariant = false;
        });

        return true;
      };

      const refreshUiFromNative = () => {
        const currentModel = getCurrentModelText();
        const currentFinish = getCurrentFinishText();
        const brands = getBrands();
        if (!brands.length) return;

        const preferredBrand = getResolvedBrandPreference();
        const currentBrand = getBrand(currentModel);
        const activeBrand =
             hasUserChosenBrand && currentBrand !== 'Other' && brands.includes(currentBrand)
           ? currentBrand
          : preferredBrand && brands.includes(preferredBrand)
         ? preferredBrand
               : currentBrand !== 'Other' && brands.includes(currentBrand)
         ? currentBrand
         : brands[0];

        const models = activeBrand ? getModelsForBrand(activeBrand) : [];

        // 初始品牌对齐（一次性）：activeBrand 与原生变体品牌不一致时（如双品牌商品
        // 默认 iPhone 但 Shopify 首变体是 Samsung），把原生 select/加购表单同步到
        // 该品牌第一个机型，避免 UI 显示 iPhone 而加购进的是 Samsung。
        if (
          !hasAutoAlignedBrand &&
          activeBrand &&
          models.length &&
          getBrand(currentModel) !== activeBrand
        ) {
          hasAutoAlignedBrand = true;
          const preferredModel = models.find(
            (model) => normalizeModel(model) === normalizeModel(currentModel)
          ) || getDefaultModelForBrand(activeBrand);
          if (syncToNativeVariant(preferredModel, finishSelectNative ? getCurrentFinishText() : '')) {
            return;
          }
        }

        const finishStates = getFinishStatesForModel(currentModel);
        const resolvedFinish = finishSelectNative
          ? getResolvedFinishForModel(currentModel, currentFinish)
          : currentFinish;

        if (finishSelectNative && resolvedFinish && normalizeFinish(currentFinish) !== normalizeFinish(resolvedFinish)) {
          syncToNativeVariant(currentModel, resolvedFinish);
          return;
        }

        if (brands.length > 1) {
          if (brandGroup) brandGroup.hidden = false;

          renderBrandButtons(brands, activeBrand, (clickedBrand) => {
  hasUserChosenBrand = true;

  const clickedModels = getModelsForBrand(clickedBrand);
  const currentModelInBrand = clickedModels.find(
    (model) => normalizeModel(model) === normalizeModel(getCurrentModelText())
  );
  const targetModel = currentModelInBrand || getDefaultModelForBrand(clickedBrand);
  if (!targetModel || !getNativeModelOption(targetModel)) return;
  unavailableRequestedModel = '';
  // Refresh even when this explicit brand choice keeps the native variant unchanged.
  lastRenderedNativeState = '';
  syncModelSelectionToUrl(targetModel);
  syncToNativeVariant(targetModel, finishSelectNative ? getCurrentFinishText() : '');
});
        } else {
          if (brandGroup) brandGroup.hidden = true;
          if (brandButtonsWrap.childElementCount) brandButtonsWrap.innerHTML = '';
        }

        if (models.length > 1) {
          if (modelGroup) modelGroup.hidden = false;

          const existingModels = Array.from(modelSelectCustom.options).map((option) => normalizeModel(option.value));
          const populatedModels = existingModels.filter(Boolean);
          const modelListChanged = populatedModels.length !== models.length ||
            models.some((model, index) => populatedModels[index] !== normalizeModel(model));

          if (modelListChanged) {
            modelSelectCustom.innerHTML = '';
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Choose a phone model';
            placeholder.disabled = true;
            modelSelectCustom.appendChild(placeholder);
            models.forEach((modelValue) => {
              const option = document.createElement('option');
              option.value = modelValue;
              option.textContent = modelValue;
              modelSelectCustom.appendChild(option);
            });
          }

          modelSelectCustom.value = models.includes(currentModel) ? currentModel : '';
        } else {
          if (modelGroup) modelGroup.hidden = true;

          if (models[0]) {
            if (modelSelectCustom.options.length !== 1 || normalizeModel(modelSelectCustom.options[0].value) !== normalizeModel(models[0])) {
              modelSelectCustom.innerHTML = '';
              const option = document.createElement('option');
              option.value = models[0];
              option.textContent = models[0];
              modelSelectCustom.appendChild(option);
            }
            modelSelectCustom.value = models[0];
          } else if (modelSelectCustom.options.length) {
            modelSelectCustom.innerHTML = '';
          }
        }

        if (finishStates.length > 1) {
          if (finishGroup) finishGroup.hidden = false;

          const existingFinishes = Array.from(finishButtonsWrap.querySelectorAll('.gc-finish-btn'))
            .map((button) => {
              return [
                normalizeFinish(button.dataset.gcFinish || button.textContent),
                button.disabled ? '0' : '1',
                normalizeText(button.textContent),
              ].join('|');
            });
          const nextFinishes = finishStates.map((state) => {
            return [
              normalizeFinish(state.value),
              state.available ? '1' : '0',
              normalizeText(state.label),
            ].join('|');
          });
          const finishListChanged = existingFinishes.length !== nextFinishes.length ||
            nextFinishes.some((signature, index) => existingFinishes[index] !== signature);

          if (finishListChanged) {
            finishButtonsWrap.innerHTML = '';
            finishStates.forEach((finishState) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'gc-finish-btn';
              btn.dataset.gcFinish = finishState.value;
              btn.textContent = finishState.label;
              btn.disabled = !finishState.available;
              btn.setAttribute('aria-disabled', String(!finishState.available));
              btn.addEventListener('click', () => {
                if (btn.disabled) return;
                syncToNativeVariant(getCurrentModelText(), finishState.value);
              });
              finishButtonsWrap.appendChild(btn);
            });
          }

          finishButtonsWrap.querySelectorAll('.gc-finish-btn').forEach((button) => {
            const finishState = finishStates.find((state) => {
              return normalizeFinish(state.value) === normalizeFinish(button.dataset.gcFinish || button.textContent);
            });
            if (finishState) {
              button.textContent = finishState.label;
              button.disabled = !finishState.available;
              button.setAttribute('aria-disabled', String(!finishState.available));
            }

            const isSelected =
              !button.disabled &&
              normalizeFinish(button.dataset.gcFinish || button.textContent) === normalizeFinish(resolvedFinish);
            button.classList.toggle('active', isSelected);
            button.setAttribute('aria-pressed', String(isSelected));
          });
        } else {
          if (finishGroup) finishGroup.hidden = true;
          if (finishButtonsWrap.childElementCount) finishButtonsWrap.innerHTML = '';
        }

        customUiWrap.hidden = false;
        visuallyHideNativeVariantUi(variantArea);
        clearBootingState();
        schedulePaymentButtonStateSync();
        updateBrandRecommendations(activeBrand, currentModel);

        const resolvedVariant = findVariantForSelection(currentModel, resolvedFinish) || getCurrentVariantFromForm();
        syncResolvedVariantState(resolvedVariant);

        if (resolvedVariant) {
          updateCustomPriceDisplay(resolvedVariant);
        }

        notifyStickyReady(resolvedVariant, resolvedFinish);
        updateModelPurchaseState(resolvedVariant);

        updatePersonalizeButtonHref({
          brand: activeBrand,
          model: unavailableRequestedModel || currentModel,
          finish: resolvedFinish,
          caseKey: config.personalizeCaseKey
        });

        lastRenderedNativeState = getNativeStateKey();
      };

      const applyIncomingSelection = () => {
        if (hasAppliedIncomingSelection) return;
        hasAppliedIncomingSelection = true;

        const requestedBrand = incomingSelection.brand;
        const requestedModel = normalizeModel(incomingSelection.model || '');
        const requestedFinish = normalizeFinish(incomingSelection.finish || '');
        const availableBrands = getBrands();
        const resolvedBrand = availableBrands.includes(requestedBrand)
          ? requestedBrand
          : getResolvedBrandPreference();
        const targetBrand = availableBrands.includes(resolvedBrand) ? resolvedBrand : '';
        const targetModel = requestedModel || (targetBrand ? getDefaultModelForBrand(targetBrand) : '');

        if (targetBrand) {
          hasUserChosenBrand = true;
        }

        if (!targetModel && !requestedFinish) {
          return;
        }

        syncToNativeVariant(targetModel || getCurrentModelText(), requestedFinish || getCurrentFinishText());
      };

      if (!hasBoundListeners) {
        modelSelectCustom.addEventListener('change', (event) => {
          const selectedModel = normalizeModel(event.target.value);
          if (!getNativeModelOption(selectedModel)) return;
          unavailableRequestedModel = '';
          // Choosing the native default can leave its state key unchanged.
          // Force a refresh so a previously blocked choice becomes purchasable.
          lastRenderedNativeState = '';
          syncModelSelectionToUrl(selectedModel);
          syncToNativeVariant(selectedModel, getCurrentFinishText());
          if (event.isTrusted) persistPhoneSelection(selectedModel);
        });

        const bindNativeSelect = (select) => {
          if (!select) return;
          const onNativeSelectChanged = (event) => {
            if (isSyncingVariant) return;
            if (select === modelSelectNative && event.type === 'change' && event.isTrusted) {
              const selectedModel = normalizeModel(getOptionText(getSelectedModelOption()));
              if (getNativeModelOption(selectedModel)) {
                unavailableRequestedModel = '';
                lastRenderedNativeState = '';
                persistPhoneSelection(selectedModel);
              }
            }
            scheduleRefreshUiFromNative();
          };

          ['change', 'input'].forEach((type) => {
            select.addEventListener(type, onNativeSelectChanged);
          });
        };

        bindNativeSelect(modelSelectNative);
        bindNativeSelect(finishSelectNative);

        const formRoot = getForm();
        if (formRoot) {
          const onVariantStateMaybeChanged = () => {
            if (isSyncingVariant) return;
            scheduleRefreshUiFromNative();
          };
          formRoot.addEventListener('change', onVariantStateMaybeChanged);
          formRoot.addEventListener('input', onVariantStateMaybeChanged);
        }

        detailsCard.addEventListener('variant:change', () => {
          if (isSyncingVariant) return;
          scheduleRefreshUiFromNative();
        });

        const formIdInput = getVariantIdInput();
        if (formIdInput) {
          const handleVariantSync = () => {
            scheduleRefreshUiFromNative();
          };

          formIdInput.addEventListener('change', handleVariantSync);
          formIdInput.addEventListener('input', handleVariantSync);
        }

        if (typeof MutationObserver === 'function') {
          paymentStateObserver = new MutationObserver((records) => {
            const checkoutBlock = getAcceleratedCheckoutBlock();
            const checkoutChanged = records.some((record) => {
              if (checkoutBlock?.contains(record.target)) {
                return record.type === 'childList' || record.target !== checkoutBlock;
              }
              if (record.type !== 'childList') return false;
              return [...record.addedNodes, ...record.removedNodes].some((node) =>
                node instanceof Element && (
                  node.matches('.accelerated-checkout-block') ||
                  node.querySelector('.accelerated-checkout-block')
                )
              );
            });
            if (checkoutChanged) schedulePaymentButtonStateSync();
          });

          paymentStateObserver.observe(detailsInner, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'disabled']
          });
        }

        hasBoundListeners = true;
      }

      applyIncomingSelection();
      refreshUiFromNative();
      loadRecommendations();
      bindMediaGalleryFilterObserver();
      schedulePaymentButtonStateSync();
      return true;
    };

    setupCaseAccordions();

    if (infoTabsWrap) {
      infoTabsWrap.querySelectorAll('[data-gc-info-tab]').forEach((btn) => {
        btn.addEventListener('click', () => {
          activateInfoPanel(btn.getAttribute('data-gc-info-tab'));
        });
      });
    }

    if (reviewToggle) {
      reviewToggle.addEventListener('click', () => {
        const extras = root.querySelectorAll('[data-gc-review-extra]');
        const willShow = Array.from(extras).some((item) => item.hidden);
        extras.forEach((item) => {
          item.hidden = !willShow;
        });
        reviewToggle.textContent = willShow ? 'Show fewer reviews' : 'More reviews';

        if (!willShow) {
          scrollReviewsBackIntoView();
        }
      });
    }

    let tries = 0;
    let bootStarted = false;
    let bootRetryTimer = 0;
    const maxBootRetries = 18;

    const stopBootRetry = () => {
      if (!bootRetryTimer) return;
      window.clearTimeout(bootRetryTimer);
      bootRetryTimer = 0;
    };

    const waitAndBoot = () => {
      tries += 1;
      const ok = boot();

      if (ok) {
        stopBootRetry();
        return;
      }

      if (tries < maxBootRetries) {
        stopBootRetry();
        bootRetryTimer = window.setTimeout(waitAndBoot, 120);
        return;
      }

      stopBootRetry();
      restoreNativeVariantUi(findVariantArea());
      notifyStickyReady();
      clearBootingState();
    };

    const startBoot = () => {
      if (bootStarted) return;

      if (document.readyState === 'loading' && !window.GoCraftlyProductEntryContext) return;

      applyEntryContext();
      bootStarted = true;
      waitAndBoot();
    };

    startBoot();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startBoot, { once: true });
    } else {
      startBoot();
    }

    window.addEventListener('load', startBoot, { once: true });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;

      const uiVisible = customUiWrap && customUiWrap.hidden === false;
      if (uiVisible) return;

      stopBootRetry();
      tries = 0;
      bootStarted = false;
      isSyncingVariant = false;
      hasUserChosenBrand = false;
      startBoot();
    });
  });
})();
